import * as types from '../constants/activityConstants';
import config from './../config.js';
import appConstants from '../appConstants';
import moment from 'moment';
// import { createStore} from 'redux';
// import combineReducers from './../reducers/combineReducers';
// let store = createStore(combineReducers);
import {cleanUnitText, getSeparator } from '../utils/utils';
import { getFormattedRate, getMinMaxFractionDigits } from '../utils/utils';

const initialState = {
  activityLog: [],
  ordcnfrmsg: {},
  physicalDeliveryOrdCnfrmMsg: {},
  tradeBook: {
    tradeBookArray:[],
    randomNo: 0,
  },
  allspotTrades:[],
  lmtFillModExpObj:{
    title: "",
    eventType: "",
    flag: false,
    ts: "",
    fixingEvent: "",
    docNo: "",
    fncNo:"",
    fixingDate:"",
    buyer: "",
    remark: "",
    remark2: ""
  },
  limitOrdBook:{
    outstandingLm:{outstandingLmArr:[],randomNo:0},
    limitOrdMap:null,
    lmCancellOrd:{lmCancellOrdArr:[],randomNo:0},
    lmFillOrd:{lmFillOrdArr:[],randomNo:0},
    lmExpOrd:{lmExpOrdArr:[],randomNo:0},
    lmtOrdersRows:[],
    randomNo:0,
    randomNopro:0
  },
  requestRejectModal:{
    mdflag:false,
    title:"",
    msg:"",
    CTID:"",
    bcm:"",
    OT:""
  },
  randomNoDB:0,
  LoadFlag:true,
  orderBookLoaderFlag:true,
  ordersRandomNoDB:0,
  ordersCTID:[],
  trdCTID:null,
  tradebookKey:'',
  statusChanged:[],
  orderSelectionFlag:false,
  dealerSelectionFlag:false,
  fixingOrdBook:{
    outstandingFix:{outstandingFixArr:[],randomNo:0},
    fixingOrdMap:null,
    fixCancellOrd:{fixCancellOrdArr:[],randomNo:0},
    fixFillOrd:{fixFillOrdArr:[],randomNo:0},
    fixOrdersRows:[],
    randomNo:0,
    randomNopro:0
  },
  fixingNotifyObj: {
    title: "",
    eventType: "",
    flag: false,
    ts: "",
    fixingEvent: "",
    docNo: "",
    fncNo:"",
    fixingDate:"",
    buyer: "",
    remark: "",
    remark2: ""
  },
  fixOrdLoaderFlag:true,
  fixOrdRandomNoDB:0,
  invalidCheck:{flag:false,Msg:""}
};

const getOutstandingorderLMT = (orderLmt, limitOrdBook) => {
  try{
  var outstandinLMTArray = [];
  var lmtOrdArr = [];
  var temMap = new Map();
  orderLmt.map((order) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const TID = user.name;
    var dec = getDecimal(order.I);
    var item1 = Object.assign([],  JSON.parse(localStorage.getItem(order.I)));
      let rate=0;
        //for (let index = 0; index < item1.length; index++) {
          //  if (item1[index].I === order.IID) {
              rate=((order.DT)===true? item1.ask:item1.bid);
          //    break;
            //}
        //  }
    var obj = {
      id: order.CLD,
      'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
      'orderNo': (order.DN
        ? order.DN
        : ""),
      'cmdtyPair': order.SD,
      'deal': (order.OT === 2 ? (order.DT===true
        ? "BUY"
        : "SELL") :
        (order.DT===true
          ? "STOP BUY"
          : "STOP SELL")),
      'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': order.OSC,
      'outstanding':(Number(parseFloat(order.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'filled':(Number(parseFloat((order.PQ)-(order.PDQ))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'price' : (order.P ? (Number(parseFloat(order.P )).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) : "0"),
      'placedBy': order.P_TC,
      'accCode': order.CC,
      'accDescription': order.AD,
      'validity': (parseInt(order.VT) === appConstants.GTD ? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : (parseInt(order.VT) === appConstants.DAY ? "DAY"
        : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC")),
      'comments': order.RMK,
      'cmdtyId': order.I,
      'selectable': true,
      'action':(order.DN
        ? order.DN
        : ""),
      'DT':order.DT===true ?1:0,
      'orderType':order.OT
    };
    var obj1 = {
      'id': order.CLD,
      'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
      'deal': (order.OT === 2 ? (order.DT===true
        ? "BUY"
        : "SELL") :
        (order.DT===true
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': order.SD,
      'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'wk':order.PQ,
      'orderNo': (order.DN
       ? order.DN
        : ""),
      'accCode': order.CC,
      'placedBy': order.P_TC,
      'accCode': order.CC,
      'accDescription': order.AD,
      'comments': order.RMK,
      'DRMK': order.DRMK,
      'OR': (Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'OSC': order.OSC,
      'OMC': parseInt(order.OMC) + 1,
      'VT' : order.VT,
      'TIME': moment.utc(order.VTE).valueOf(),
      'OTIME': order.OLDVTE,
      'OVT': order.VT,
      'BID': order.BID,
      'VD': order.DD,
      'CTID': order.CLD,
      'cmdtyId': order.I,
      'DT':order.DT===true ?1:0,
      'orderType':order.OT
    };
    var obj2 = {
      id: order.CLD,
      'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
      'status': 'Outstanding',
      'deal': (order.OT === 2 ? (order.DT===true
        ? "BUY"
        : "SELL") :
        (order.DT===true
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': order.SD,
      'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': order.OSC,
      'rate': Number((order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
      'validity': (parseInt(order.VT) === appConstants.GTD ? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : (parseInt(order.VT) === appConstants.DAY ? "DAY"
          : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC")),
      'orderNo': (order.DN
       ? order.DN
        : ""),
      'docNo': '',
      'placedBy': order.P_TC,
      'accCode': order.CC,
      'accDescription': order.AD,
      'comments': order.RMK,
      'cmdtyId': order.IID,
      'selectable': true,
      'action':(order.DN
        ? order.DN
        : ""),
      'DT':order.DT===true ?1:0,
      'orderType':order.OT
      };
    outstandinLMTArray.push(obj);
    lmtOrdArr.push(obj2);
    temMap.set(order.DN, obj1);
  });
  limitOrdBook.outstandingLm.outstandingLmArr = outstandinLMTArray;
  //limitOrdBook.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
  limitOrdBook.limitOrdMap = temMap;
  limitOrdBook.lmtOrdersRows = lmtOrdArr;
}catch(e){console.log(e);}
  //localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
  localStorage.setItem('outstandingLm', JSON.stringify(limitOrdBook.outstandingLm));
  return outstandinLMTArray;
}

const getallspot = (orderspot,tradeBook) => {
  var tradeBookArr = [];
  orderspot.map((order) => {
    var dec = getDecimal(order.IID);
    const user = JSON.parse(localStorage.getItem('user'));
    const TID = user.name;
    var obj = {
      'id': '',
      'eventTime': moment(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
      'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
      'cmdtyPair':  order.SD,
      'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': order.OSC,
      'rate': Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
      'docNo': order.DN,
      'valDate': moment(order.VD).format(appConstants.rptDateFormat),
      'user': order.TC,
      'accDescription': order.AD,
      'comments': order.RMK,
      'cmdtyId': order.IID
    };
    tradeBookArr.push(obj);
    });
    tradeBook.tradeBookArray = tradeBookArr;
    //localStorage.setItem('tradeBook', JSON.stringify(tradeBook));
    return tradeBook;
}

const getOpenTrades = (openTrade,opentradeBook ) => {
	  try{
		  var openTradeArr=new Map();
		  var tempArr=JSON.parse(localStorage.getItem('convFactor'));
		  var convFactor = new Map(tempArr.map(i => [i.key, i.val]));
		  const user = JSON.parse(localStorage.getItem('user'));
		    const TID = user.name;
		    var mult=1;
		  openTrade.map((order) => {
        var dec = getDecimal(order.inst_id);
        const item1 = Object.assign([], JSON.parse(localStorage.getItem(order.inst_id)));
        let cmdtypair = item1.ID
		    if(convFactor.get(order.stk_code)!==undefined){
		    	mult=convFactor.get(order.stk_code);
		    }
		    var obj = {
		      'eventTime': moment(order.event_time).local().format(appConstants.actTimeDateTimeFormatter),
		      'deal': (order.deal_type) === true
		          ? "BUY"
		          : "SELL",
          'cmdtyPair':cmdtypair,
		      'iid':order.inst_id,
		      'quantity':(Number(parseFloat(order.bal_pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
		      'qtyType': order.stk_code,
		      'price': Number(parseFloat(order.rate)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
		      'gq':order.bal_pcs_qty*mult,
		      'rate':order.rate,
		      'docNo': order.docno,
		      'unrealisedPL': order.PnL,
		      'trade': (order.deal_type) === true
		          ? "SELL"
		          : "BUY"
		    };
			    if(openTradeArr.get(order.inst_id)){
			    	openTradeArr.get(order.inst_id).push(obj);
			    }
			    else{
			    	localStorage.setItem('opTrade',1);
			    	var tempArr=[];
			    	tempArr.push(obj);
			    	openTradeArr.set(order.inst_id,tempArr);
			    }
		    });
		    opentradeBook.opentradesData = openTradeArr;
		    return opentradeBook;
	  	}catch(e){console.log("Error"+e);}
}

const openTrdBookSet = (opentradeBook,msgObj) =>{
	 try{
		 if(msgObj.BCM===appConstants.OPEN_TRADE){
			 if(msgObj.Type ==="Modify"){
				 var docArr=msgObj.DocData;
				 for(var k=0;k<docArr.length;k++){
					 var tempArr=opentradeBook.opentradesData.get(docArr[k].IID).push(obj);
					 for(var j=0;j<tempArr.length;j++){
						 if(tempArr[i].docNo===docArr[k].DocNo){
							 tempArr.splice(i);
							 break;
						 }
					 }
					 opentradeBook.opentradesData.set(docArr[k].IID,tempArr);
				 }
			 }else{
				 //To add
				 var tempcArr=JSON.parse(localStorage.getItem('convFactor'));
				  var convFactor = new Map(tempcArr.map(i => [i.key, i.val]));
				  var docArr=msgObj.DocData;
					 for(var k=0;k<docArr.length;k++){
						 var dec = getDecimal(docArr[k].IID);
             const item1 = Object.assign([], JSON.parse(localStorage.getItem(docArr[k].IID)));
             let cmdtypair = item1.ID
						 var obj = {
							      'eventTime': moment().local().format(appConstants.actTimeDateTimeFormatter),
							      'deal': (docArr[k].DT) === true
							          ? "BUY"
							          : "SELL",
                    'cmdtyPair':cmdtypair,
							      'iid':docArr[k].IID,
							      'quantity':(Number(parseFloat(docArr[k].Qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
							      'qtyType': docArr[k].SC,
							      'price': Number(parseFloat(docArr[k].R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
							      'rate':docArr[k].R,
							      'gq':docArr[k].Qty*convFactor.get(docArr[k].SC),
							      'docNo': docArr[k].DocNo,
							      'unrealisedPL':0.00,
							      'trade': (docArr[k].DT) === true
							          ? "SELL"
							          : "BUY"
							    };
						 var tempArr=opentradeBook.opentradesData.get(docArr[k].IID);
						 tempArr.push(obj);
						 opentradeBook.opentradesData.set(docArr[k].IID,tempArr);
					 }
		 }
     opentradeBook.randomNo = Math.floor((Math.random() * 10) + 1);
	 }
		 return opentradeBook;
	 }catch(e){console.log(e);}
 }

const getCancelledLMT = (cancelledLMT, limitOrdBook)=>{
   const AD = JSON.parse(localStorage.getItem('DFA')).D;
   var cancelledLMTArray = [];
   var lmtOrdArr = limitOrdBook.lmtOrdersRows;
   cancelledLMT.map((order) => {
     var dec = getDecimal(order.I);
  var obj = {
     'eventTime':moment(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
     'deal': (order.OT === 2 ? (order.DT===true
       ? "BUY"
       : "SELL") :
       (order.DT===true
         ? "STOP BUY"
         : "STOP SELL")),
     'cmdtyPair': order.ST,
     'quantity': (Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
     'qtyType': order.SC,
     'rate': Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
     'validity':parseFloat(order.VT) === 6 ? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : parseFloat(order.VT) === 0 ? "DAY"
        : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC",
      'placedBy': order.P_TC,
      'cancelledBy': order.TC,
      'accDescription': AD,
     'orderNo': order.DN,
     'cmdtyId': order.I
   }
   var obj2 = {
     id: order.ID,
     'eventTime': moment(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
     'status':'Cancelled',
     'deal': (order.OT === 2 ? (order.DT===true
       ? "BUY"
       : "SELL") :
       (order.DT===true
         ? "STOP BUY"
         : "STOP SELL")),
     'cmdtyPair': order.ST,
     'quantity': (Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
     'qtyType': order.SC,
     'rate': Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
     'validity':parseFloat(order.VT) === 6 ? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : parseFloat(order.VT) === 0 ? "DAY"
        : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC",
     'orderNo': order.DN,
     'placedBy': order.P_TC,
     'cancelledBy': order.TC,
     'accDescription': AD,
     'docNo':'',
     'comments': order.R,
     'cmdtyId': order.I,
     'selectable': false
   };
   lmtOrdArr.push(obj2);
   cancelledLMTArray.push(obj);
 });
 limitOrdBook.lmCancellOrd.lmCancellOrdArr = cancelledLMTArray;
 limitOrdBook.lmtOrdersRows = lmtOrdArr;
 //localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
    return cancelledLMTArray;
 }

const getFilledLMT = (filledLm, limitOrdBook) => {
   try{
   const AD = JSON.parse(localStorage.getItem('DFA')).D;
   var filledLMArray = [];
   var filledLMtempArr = limitOrdBook.lmtOrdersRows ;
   filledLm.map((order) => {
     var dec = getDecimal(order.I);
     var obj = {
       'eventTime': moment.utc(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
       'deal': (order.OT === 2 ? (order.DT===true
         ? "BUY"
         : "SELL") :
         (order.DT===true
           ? "STOP BUY"
           : "STOP SELL")),
       'cmdtyPair': order.ST,
       'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
       'qtyType': order.SC,
       'rate':  Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
       'validity':(parseInt(order.VT) === appConstants.GTD? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : (parseInt(order.VT) === appConstants.DAY ? "DAY"
            : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC")),
       'docNo': order.FD,
       'orderNo': order.DN,
       'valDate':  moment(order.VD).format(appConstants.rptDateFormat),
       'placedBy': order.P_TC,
       'comments': order.R,
       'accDescription': AD,
       'cmdtyId': order.I
     };

     var obj2 = {
       id: order.ID,
       'eventTime': moment.utc(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
       'status':'Filled',
       'deal': (order.OT === 2 ? (order.DT===true
         ? "BUY"
         : "SELL") :
         (order.DT===true
           ? "STOP BUY"
           : "STOP SELL")),
       'cmdtyPair': order.ST,
       'quantity': (Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
       'qtyType': order.SC,
       'rate':  Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
       'validity':(parseInt(order.VT) === appConstants.GTD? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : (parseInt(order.VT) === appConstants.DAY ? "DAY"
            : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC")),
       'orderNo': order.DN,
       'placedBy': order.P_TC,
       'docNo':order.FD,
       'accDescription': AD,
       'comments': order.R,
       'cmdtyId': order.I,
       'selectable': false
     };
     filledLMtempArr.push(obj2);
     filledLMArray.push(obj);
   });
   limitOrdBook.lmFillOrd.lmFillOrdArr = filledLMArray;
   limitOrdBook.lmtOrdersRows = filledLMtempArr;
 }catch(e){console.log(e);}
   //localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
   return filledLMArray;
 }

const getExpiredLMT= (expiredLMT,limitOrdBook)=>{
   const AD = JSON.parse(localStorage.getItem('DFA')).D;
   var expiredLMTArray = [];
   var expiredLMTtempArr = limitOrdBook.lmtOrdersRows ;
   expiredLMT.map((order) => {
     var dec = getDecimal(order.I);
     const user = JSON.parse(localStorage.getItem('user'));
   var obj = {
     'eventTime': moment.utc(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
     'deal': (order.OT === 2 ? (order.DT===true
       ? "BUY"
       : "SELL") :
       (order.DT===true
         ? "STOP BUY"
         : "STOP SELL")),
     'cmdtyPair': order.ST,
     'quantity': (Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
     'qtyType': order.SC,
     'rate': (Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
     'validity':(parseInt(order.VT) === appConstants.GTD? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : (parseInt(order.VT) === appConstants.DAY ? "DAY"
          : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC")),
     'orderNo': order.DN,
     'placedBy': order.P_TC,
     'accDescription': AD,
     'cmdtyId': order.I
   }

   var obj2 = {
     'eventTime': moment.utc(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
     'status':'Expired',
     'deal': (order.OT === 2 ? (order.DT===true
       ? "BUY"
       : "SELL") :
       (order.DT===true
         ? "STOP BUY"
         : "STOP SELL")),
     'cmdtyPair': order.ST,
     'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
     'qtyType': order.SC,
     'rate':  Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
     'validity':(parseInt(order.VT) === appConstants.GTD? "GTD "+moment.utc(order.VTE).local().format(appConstants.ymmdd) : (parseInt(order.VT) === appConstants.DAY ? "DAY"
          : parseInt(order.VT) === appConstants.GTT ? "GTT "+moment.utc(order.VTE).local().format(appConstants.validityDateFormat) :"GTC")),
     'orderNo': order.DN,
     'placedBy': order.P_TC,
     'docNo':'',
     'accDescription': AD,
     'comments': order.R,
     'cmdtyId': order.I,
     'selectable': false
   };

   expiredLMTArray.push(obj);
   expiredLMTtempArr.push(obj2);
 });
 limitOrdBook.lmExpOrd.lmExpOrdArr = expiredLMTArray;
 limitOrdBook.lmtOrdersRows = expiredLMTtempArr;
  //localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
 return expiredLMTArray;
}

/*------------Fixing Order Functions -----------*/
const getOutstandingFixOrd = (orderFix, fixingOrdBook) => {
  try{
    var outstandinFixArray = [];
    var fixOrdArr = [];
    var temMap = new Map();
    orderFix.map((order) => {
      const user = JSON.parse(localStorage.getItem('user'));
      const TID = user.name;
      var dec = getDecimal(order.IID);
      var item1 = Object.assign([],  JSON.parse(localStorage.getItem(order.IID)));
      let rate=0;
      rate=((order.DT)===true? item1.ask:item1.bid);
      var obj = {
        'id': order.CLD,
        'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
        'orderNo': (order.DN ? order.DN : ""),
        'fixingDate':moment(order.FD).format(appConstants.rptDateFormat),
        'fixingEvent':order.FCD,
        'fixingEventCode':order.FC,
        'fixingTime':order.FT,
        'cmdtyPair': order.SD,
        'deal':  (order.DT===true ? "BUY" : "SELL") ,
        'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'qtyType': order.OSC,
        'price' : (order.P ? (Number(parseFloat(order.P )).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) : "0"),
        'placedBy': order.P_TC,
        'accCode': order.AC,
        'accDescription': order.AD,
        'comments': order.RMK,
        'cmdtyId': order.IID,
        'selectable': true,
        'action':(order.DN ? order.DN : ""),
        'DT':order.DT===true ?1:0,
      };
      var obj1 = {
        'id': order.CLD,
        'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
        'deal': (order.DT===true ? "BUY" : "SELL"),
        'fixingDate':moment(order.FD).format(appConstants.rptDateFormat),
        'fixingEvent':order.FCD,
        'fixingEventCode':order.FC,
        'fixingTime':order.FT,
        'cmdtyPair': order.SD,
        'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'orderNo': (order.DN ? order.DN : ""),
        'accCode': order.AC,
        'placedBy': order.P_TC,
        'accDescription': order.AD,
        'comments': order.RMK,
        'OR': (Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
        'OSC': order.OSC,
        'BID': order.BID,
        'VD': order.DD,
        'CTID': order.CLID,
        'cmdtyId': order.IID,
        'DT':order.DT===true ?1:0,
      };
      var obj2 = {
        'id': order.CLD,
        'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
        'status': 'Outstanding',
        'deal': (order.DT===true ? "BUY" : "SELL"),
        'fixingDate':moment(order.FD).format(appConstants.rptDateFormat),
        'fixingEvent':order.FCD,
        'fixingEventCode':order.FC,
        'fixingTime':order.FT,
        'cmdtyPair': order.SD,
        'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'qtyType': order.OSC,
        'rate': "",
        'orderNo': (order.DN ? order.DN : ""),
        'docNo': '',
        'placedBy': order.P_TC,
        'accCode': order.AC,
        'accDescription': order.AD,
        'comments': order.RMK,
        'cmdtyId': order.IID,
        'selectable': true,
        'action':(order.DN ? order.DN : ""),
        'DT':order.DT===true ?1:0,
        };
      outstandinFixArray.push(obj);
      fixOrdArr.push(obj2);
      temMap.set(order.DN, obj1);
    });
    fixingOrdBook.outstandingFix.outstandingFixArr = outstandinFixArray;
    //fixingOrdBook.outstandingFix.randomNo = Math.floor((Math.random() * 1000000) + 1);
    fixingOrdBook.fixingOrdMap = temMap;
    fixingOrdBook.fixOrdersRows = fixOrdArr;
  }catch(e){console.log(e);}
  //localStorage.setItem('fixingOrdBook', JSON.stringify(fixingOrdBook));
  localStorage.setItem('outstandingFix', JSON.stringify(fixingOrdBook.outstandingFix));
  return outstandinFixArray;
}

const getCancelledFixOrd = (cancelledFix, fixingOrdBook)=>{
  const AD = JSON.parse(localStorage.getItem('DFA')).D;
  var cancelledFixArray = [];
  var fixOrdArr = fixingOrdBook.fixOrdersRows;
  cancelledFix.map((order) => {
    var dec = getDecimal(order.IID);
    var obj = {
      'eventTime':moment(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
      'deal': (order.DT===true ? "BUY" : "SELL") ,
      'fixingDate':moment(order.FD).format(appConstants.rptDateFormat),
      'fixingEvent':order.FCD,
      'fixingEventCode':order.FC,
      'fixingTime':order.FT,
      'cmdtyPair': order.SD,
      'quantity': (Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': order.OSC,
      'rate': Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
      'orderNo': order.DN,
      'placedBy': order.P_TC,
      'cancelledBy': order.TC,
      'accDescription':AD,
      'comments': order.RMK,
      'cmdtyId': order.IID
    }

    var obj2 = {
      'id': order.ID,
      'eventTime': moment(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
      'status':'Cancelled',
      'deal': (order.DT===true ? "BUY" : "SELL"),
      'fixingDate':moment(order.FD).format(appConstants.rptDateFormat),
      'fixingEvent':order.FCD,
      'fixingEventCode':order.FC,
      'fixingTime':order.FT,
      'cmdtyPair': order.SD,
      'quantity': (Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': order.OSC,
      'rate': "",
      'orderNo': order.DN,
      'docNo':'',
      'placedBy': order.P_TC,
      'accDescription':AD,
      'cancelledBy': order.TC,
      'comments': order.RMK,
      'cmdtyId': order.IID,
      'selectable': false
    };
    fixOrdArr.push(obj2);
    cancelledFixArray.push(obj);
  });
  fixingOrdBook.fixCancellOrd.fixCancellOrdArr = cancelledFixArray;
  fixingOrdBook.fixOrdersRows = fixOrdArr;
  //localStorage.setItem('fixingOrdBook', JSON.stringify(fixingOrdBook));
  return cancelledFixArray;
}

const getFilledFixOrd= (filledFix, fixingOrdBook) => {
   try{
     const AD = JSON.parse(localStorage.getItem('DFA')).D;
     var filledFixArray = [];
     var filledFixtempArr = fixingOrdBook.fixOrdersRows ;
     filledFix.map((order) => {
       var dec = getDecimal(order.IID);
       var obj = {
         'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
         'deal': (order.DT===true ? "BUY" : "SELL"),
         'fixingDate':moment(order.FD).format(appConstants.rptDateFormat),
         'fixingEvent':order.FCD,
         'fixingEventCode':order.FC,
         'fixingTime':order.FT,
         'cmdtyPair': order.SD,
         'quantity':(Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
         'qtyType': order.OSC,
         'rate':  Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
         'docNo': order.NFD,
         'orderNo': order.DN,
         'valDate':  moment(order.VD).format(appConstants.rptDateFormat),
         'comments': order.RMK,
         'placedBy': order.P_TC,
         'filledBy': order.TC,
         'accDescription': AD,
         'cmdtyId': order.IID
       };

       var obj2 = {
         'id': order.ID,
         'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
         'status':'Filled',
         'deal': (order.DT===true ? "BUY" : "SELL") ,
         'fixingDate':moment(order.FD).format(appConstants.rptDateFormat),
         'fixingEvent':order.FCD,
         'fixingEventCode':order.FC,
         'fixingTime':order.FT,
         'cmdtyPair': order.SD,
         'quantity': (Number(parseFloat(order.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
         'qtyType': order.OSC,
         'rate':  Number(parseFloat(order.P)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
         'orderNo': order.DN,
         'docNo':order.NFD,
         'placedBy': order.P_TC,
         'filledBy': order.TC,
         'accDescription':AD,
         'comments': order.RMK,
         'cmdtyId': order.IID,
         'selectable': false
       };
       filledFixtempArr.push(obj2);
       filledFixArray.push(obj);
     });
     fixingOrdBook.fixFillOrd.fixFillOrdArr = filledFixArray;
     fixingOrdBook.fixOrdersRows = filledFixtempArr;
   }catch(e){console.log(e);}
   //localStorage.setItem('fixingOrdBook', JSON.stringify(fixingOrdBook));
   return filledFixArray;
 }

const closeBMModal = (benmFillObj) => {
  var obj1 = {
    title: "",
    flag: false,
    eventType: "",
    ts: "",
    fixingEvent: "",
    docNo: "",
    fixingDate:"",
    buyer: "",
    remark: "",
    remark2: ""
  };
  var obj2 = {
    title: "",
    eventType: "",
    flag: false,
    ts: "",
    fixingEvent: "",
    docNo: "",
    fixingDate:"",
    buyer: "",
    remark: "",
    remark2: ""
  };
  localStorage.setItem('fixFillObj',JSON.stringify(obj1));
  localStorage.setItem('fixFillObjflag',false);
  localStorage.setItem('lmtFillModExpObj',JSON.stringify(obj2));
  return obj1;
}

const getDecimal = (cmdtypair) => {
  var dec;
  var item =JSON.parse(localStorage.getItem(cmdtypair));
  //for (let index = 0; index < item.length; index++) {
    //  if (item[index].I === cmdtypair) {
        dec = item.dec
  //      break;
  //  }
//  }
  return dec;
}

const getBMKDecimal = (cmdtypair) => {
  var dec;
  var item =JSON.parse(localStorage.getItem(cmdtypair));
  //for (let index = 0; index < item.length; index++) {
//      if (item[index].I === cmdtypair) {
        dec = item.BMdec
  //      break;
  //  }
  //}
  return dec;
}

export function marginCheckNotification(msg, activityLog) {
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
    if(parseInt(msg.OT)===2 || parseInt(msg.OT)===3 ){
      obj.docNo = (msg.NOD
        ? msg.NOD
        : "");
    }
    // else if(parseInt(msg.OT)===5){
    //   obj.docNo = (msg.ONB
    //     ? msg.ONB
    //     : "");
    // }
    else if(parseInt(msg.OT)===4){
      obj.docNo = (msg.DN
        ? msg.DN
        : "");
    }
  let remark = "";
  const type=(msg.OT
    ? msg.OT
    : "1");
    const msgType=msg.OMT;
    if(parseInt(type)===1){
      remark="Trade unsuccessful. "
    }else if(parseInt(msgType)===2){
      remark="Modify unsuccessful. "
    }else if(parseInt(msgType)===6){
      remark="Cancel unsuccessful. "
    } else if(parseInt(type)===4){
 		 remark="Fixing Order unsuccessful. "
 	  } else{
      remark="Order unsuccessful. "
    }
  switch (msg.STATUS) {
    case appConstants.SUB_COMP_STATUS_INACTIVE:
      remark=remark+ "Trading Disabled. Please contact your trading desk.";
      break;
    case appConstants.TRD_ROUTE_ISSUE:
      remark=remark+ "Please contact your trading desk.";
      break;
    case appConstants.SESSION_EXP:
      remark=remark+ "Your session has expired. Please login again.";
      break;
    case appConstants.REJ_ACCLOCKED:
      remark=remark+ " Another trader is executing in this account.";
      break;
    case appConstants.MRG_FAILED:
      remark=remark+ "Insufficient margins.";
      break;
    case appConstants.FUNDS_REVAL_ZERO:
      remark=remark+ "Funds and revaluation is zero.";
      break;
    case appConstants.WORST_NOP_BREACH:
      remark=remark+ "The value of your position plus outstanding orders cannot exceed your NOP limit.";
      break;
    case appConstants.INVALID_DATE:
      remark=remark+ "The expiry Date you entered falls on a non-business day.";
      break;
    case appConstants.ORD_FILLED:
      remark=remark+ "This order has already been filled and cannot be modified.";
      break;
    case appConstants.EXCEEDS_TRDLIMIT:
      remark=remark+ " Trade request quantity exceeds Trade Quantity Limit.";
      break;
    case appConstants.EXCEEDS_EXPOSURE:
      remark=remark+ "The value exceeds your overall exposure limit.";
      break;
    case appConstants.INSUFFICIENT_MRG:
      remark=remark+ "Your margin levels are insufficient.";
      break;
    case appConstants.EXCEEDS_ORDLIMIT:
      remark=remark+ "Trade value exceeds Deal Value Limit.";
      break;
    case appConstants.QTY_GREATER_THAN_MAX_HEDGE_QTY:
      remark=remark+ "Quantity exceeds maximum quantity limit.";
      break;
    case appConstants.QTY_LESS_THAN_MIN_HEDGE_QTY:
      remark=remark+ "Quantity less than min quantity limit.";
      break;
    case appConstants.TRD_PROCESS_ISSUE:
      remark=remark+ "Deal request could not be processed. Please try after some time alert.";
      break;
    case appConstants.NO_DEALER:
      remark=remark+ "There's no dealer available. Please contact your trading desk.";
      break;
    case appConstants.TRD_DISABLED:
      remark=remark+ "This commodity is unavailable to you. Please contact your trading desk.";
      break;
    // case appConstants.TRD_ROUTE_ISSUE:
    //   remark=remark+ "There's a problem with the price feed. Please contact your trading desk.";
    //   break;
    // case appConstants.SESSION_EXP:
    //   remark=remark+ "Your session has expired. Please login again.";
    //   break;
    case appConstants.TRD_PLACE_FAIL:
      remark=remark+ " Please try again.";
      break;
    // case appConstants.INVALID_DATE:
    //   remark=remark+ "The expiry time you entered falls on a non-business day.";
    //   break;
    // case appConstants.REJ_ACCLOCKED:
    //   remark=remark+ "Another trader is executing in this account.";
    //   break;
    // case appConstants.FUNDS_REVAL_ZERO:
    //   remark=remark+ "Funds and revaluation is zero.";
    //   break;
    // case appConstants.WORST_NOP_BREACH:
    //   remark=remark+ "The value of your position plus outstanding orders cannot exceed your NOP limit.";
    //   break;
    case appConstants.BM_NOT_VALID:
      remark=remark+ "This benchmark is no longer available for new orders or modifications. \n Please contact your Dealing Desk.";
      break;
    case appConstants.MRK_ORD_CACNEL:
      remark=remark+ "Trader cannot modify/cancel marked orders.";
      break;
    case appConstants.NO_PRICE:
      remark=remark+ "No price for this Commodity.";
      break;
    case appConstants.PREV_ORDER_REQUEST_INPROGRESS:
      remark=msg.OMT === 2? "Modification request rejected. Previous modification/cancellation request is in progress." : msg.OMT=== 6? "Cancellation request rejected. Previous modification/cancellation request is in progress.":"";
      break;
    case appConstants.FX_NOT_VALID:
      remark=remark+ "Fixing Event not valid for the day.";
      break;
    case appConstants.HOLIDAY:
      remark=remark+ "Fixing event marked as a holiday.";
      break;
    case appConstants.MKT_LMT_NOT_ALLOW:
      remark=remark+ "Trading date falls on a holiday.";
      break; 
    case appConstants.WEEKNED:
      remark=remark+ "The Fixing date falls on a holiday.";
      break;
    case appConstants.FX_OUTOF_DATE_RANGE:
      remark=remark+ "Fixing date is out of range.";
      break;
    case appConstants.FXDATE_BEFORE_DOCDATE:
      remark=remark+ "The selected Fixing Date cannot be before Doc Date.";
      break;
    case appConstants.FX_NOT_ALLOW:
      remark=remark+ "Fixing modification/cancellation not allowed after trade day.";
      break;

    default:
      remark=remark+ "Please try again.";
      break;
  }
  obj.remark = remark;
  activityLog.unshift(obj);
  return activityLog;
}

export function generatePhysicalDeliveyMarginCheckFailSuffix(msg) {

  let remark = "";

  switch (msg.RISK_CHECK_STATUS) {
    case appConstants.EXCEEDS_EXPOSURE: //101
      remark += "The value exceeds your overall exposure limit.";
      break;
    case appConstants.INSUFFICIENT_MRG: // 102
    case appConstants.REQ_CONF_FOR_MRG: // 111
      remark += "Margin levels are insufficient.";
      break;
    case appConstants.FUNDS_REVAL_ZERO: // 120
      remark += "Funds and Revaluation is zero.";
      break;
    case appConstants.NOT_ENOUGH_FUND_TO_BUY: // 124
      remark += "Not enough funds to process the request.";
      break;
    case appConstants.NOT_ENOUGH_STK_POSITION_TO_SELL: //125
      remark += "Not enough position to process the request.";
      break;
    default:
      remark += "Please try again.";
      break;
  }

  return remark;
}

export function cancelPartialFilled(msg, activityLog) {
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
    if(parseInt(msg.OT)===2){
      obj.docNo = (msg.NOD
        ? msg.NOD
        : "");
    }else if(parseInt(msg.OT)===5){
      obj.docNo = (msg.ONB
        ? msg.ONB
        : "");
    }
  let remark = "";
  const type=(msg.OT
    ? msg.OT
    : "1");
    const msgType=msg.OMT;
     if(parseInt(msgType)===6 && appConstants.ORD_PARTIAL_FILL){
      remark="Cancel order request rejected. Please contact trading desk."
    }
    if(parseInt(msgType)===2 && appConstants.ORD_PARTIAL_FILL){
     remark="Modify order request rejected. Please contact trading desk."
   }
  obj.remark = remark;
  activityLog.unshift(obj);
  return activityLog;
}

export function isSingleCancel(msg) {
  if(msg.OMT===6 && msg.BCM===appConstants.ORD_CANCEL || msg.OMT===6 && msg.BCM === appConstants.FIXING_ORDER_CANCELLED){
    var user = JSON.parse(localStorage.getItem('userDetail'));
    if(msg.PCT===10 || msg.PCT === 19 || (msg.PCT===4 && msg.platform !=="Desktop")){//// Made Changed of  (msg.PCT===4 && msg.platform !=="Desktop") for bug 8782 
      return true;
    } else if(msg.UID!==user.UID){
      return true;
    }
     else{
      return false;
    }
  }else{
    return false;
  }
}
export function checkStatusChange(msg, statusChanged) {
  statusChanged=[];
  var obj = {};
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let status_val = "";
  let reason="";

  if(msg.OMT===6 && (msg.BCM===appConstants.MARGIN_CHECKS_FAILED ||
    msg.BCM===appConstants.INITIAL_CHECKS_FAILED)){
      switch (msg.STATUS) {
        case appConstants.SUB_COMP_STATUS_INACTIVE:
          status_val="Cancel Failed";
          reason= "Trading Disabled. Please contact your trading desk.";
          break;
        case appConstants.TRD_ROUTE_ISSUE:
        status_val="Cancel Failed";
          reason= "Please contact your trading desk.";
          break;
        case appConstants.SESSION_EXP:
        status_val="Cancel Failed";
          reason= "Your session has expired. Please login again.";
          break;
        case appConstants.REJ_ACCLOCKED:
        status_val="Cancel Failed";
          reason= " Another trader is executing in this account.";
          break;
        case appConstants.MRG_FAILED:
        status_val="Cancel Failed";
          reason= "Insufficient margins.";
          break;
        case appConstants.FUNDS_REVAL_ZERO:
         status_val="Cancel Failed";
          reason= "Funds and revaluation is zero.";
          break;
        case appConstants.WORST_NOP_BREACH:
        status_val="Cancel Failed";
          reason= "The value of your position plus outstanding orders cannot exceed your NOP limit.";
          break;
        case appConstants.INVALID_DATE:
        status_val="Cancel Failed";
          reason= "The expiry Date you entered falls on a non-business day.";
          break;
        case appConstants.ORD_FILLED:
        status_val="Cancel Failed";
          reason= "This order has already been filled and cannot be modified.";
          break;
        case appConstants.EXCEEDS_TRDLIMIT:
        status_val="Cancel Failed";
          reason= " Trade request quantity exceeds Trade Quantity Limit.";
          break;
        case appConstants.EXCEEDS_EXPOSURE:
        status_val="Cancel Failed";
          reason= "The value exceeds your overall exposure limit.";
          break;
        case appConstants.INSUFFICIENT_MRG:
        status_val="Cancel Failed";
          reason= "Your margin levels are insufficient.";
          break;
        case appConstants.EXCEEDS_ORDLIMIT:
        status_val="Cancel Failed";
          reason= "Trade value exceeds Deal Value Limit.";
          break;
        case appConstants.QTY_GREATER_THAN_MAX_HEDGE_QTY:
        status_val="Cancel Failed";
          reason= "Quantity exceeds maximum quantity limit.";
          break;
        case appConstants.QTY_LESS_THAN_MIN_HEDGE_QTY:
        status_val="Cancel Failed";
          reason= "Quantity less than min quantity limit.";
          break;
        case appConstants.TRD_PROCESS_ISSUE:
        status_val="Cancel Failed";
        reason= "Deal request could not be processed. Please try after some time alert.";
          break;
        case appConstants.NO_DEALER:
        status_val="Cancel Failed";
          reason= "There's no dealer available. Please contact your trading desk.";
          break;
        case appConstants.TRD_DISABLED:
        status_val="Cancel Failed";
          reason= "This commodity is unavailable to you. Please contact your trading desk.";
          break;
        // case appConstants.TRD_ROUTE_ISSUE:
        //   remark=remark+ "There's a problem with the price feed. Please contact your trading desk.";
        //   break;
        // case appConstants.SESSION_EXP:
        //   remark=remark+ "Your session has expired. Please login again.";
        //   break;
        case appConstants.TRD_PLACE_FAIL:
        status_val="Cancel Failed";
          reason= " Please try again.";
          break;
        // case appConstants.INVALID_DATE:
        //   remark=remark+ "The expiry time you entered falls on a non-business day.";
        //   break;
        // case appConstants.REJ_ACCLOCKED:
        //   remark=remark+ "Another trader is executing in this account.";
        //   break;
        // case appConstants.FUNDS_REVAL_ZERO:
        //   remark=remark+ "Funds and revaluation is zero.";
        //   break;
        // case appConstants.WORST_NOP_BREACH:
        //   remark=remark+ "The value of your position plus outstanding orders cannot exceed your NOP limit.";
        //   break;
        case appConstants.BM_NOT_VALID:
          status_val="Cancel Failed";
          reason= "This benchmark is no longer available for new orders or modifications. \n Please contact your Dealing Desk.";
          break;
        case appConstants.MRK_ORD_CACNEL:
          status_val="Cancel Failed";
          reason= "Trader cannot modify/cancel marked orders.";
          break;
        case appConstants.NO_PRICE:
          status_val="Cancel Failed";
          reason= "No price for this Commodity.";
          break;

        case appConstants.PREV_ORDER_REQUEST_INPROGRESS:
          status_val="Cancel Failed";
          reason= "Previous cancellation request is in progress.";
          break;

        case appConstants.FX_NOT_VALID:
          status_val="Cancel Failed";
          reason = "Fixing Event not valid for the day.";
          break;

          case appConstants.HOLIDAY:
            status_val="Cancel Failed";
            reason = "Fixing event marked as a holiday.";
            break;
  
          case appConstants.MKT_LMT_NOT_ALLOW:
            status_val="Cancel Failed";
            reason = "Trading date falls on a holiday.";
            break; 

        case appConstants.WEEKNED:
          status_val="Cancel Failed";
          reason = "The Fixing date falls on a holiday.";
          break;

        case appConstants.FX_OUTOF_DATE_RANGE:
          status_val="Cancel Failed";
          reason = "Fixing date is out of range.";
          break;

        case appConstants.FXDATE_BEFORE_DOCDATE:
          status_val="Cancel Failed";
          reason = "The selected Fixing Date cannot be before Doc Date.";
          break;

        case appConstants.FX_NOT_ALLOW:
          status_val="Cancel Failed";
          reason = "Fixing modification/cancellation not allowed after trade day.";
          break;

        default:
          status_val="Cancel Failed";
          reason= "Please try again.";
          break;
      }
  } else if(msg.OMT===6 && msg.BCM=== appConstants.ORD_PARTIAL_FILL){
    status_val="Cancel Failed";
    reason="Cancellation Failed,Please contact your trading desk.";
  } else if(msg.OMT===6 && msg.BCM===appConstants.ORD_CANCEL || msg.BCM === appConstants.FIXING_ORDER_CANCELLED){
    status_val="Cancelled";
    reason="";
  } else if(msg.OMT===6 && msg.BCM===appConstants.REQUEST_REJECT) {
    status_val="Cancel Failed";
    reason="Your cancel request was unsuccessful,Please try again."
  }  else if(msg.OMT===6 && msg.BCM===appConstants.INVALID_CHECK) {
     status_val="Invalid Request";
     reason="Trade request rejected because of invalid parameters. Please login and try again"
  }
  obj.status_val=status_val;
  obj.reason=reason;
  statusChanged.unshift(obj);
  for(var i=0; i<statusChanged.length;i++){
    if(statusChanged[i].status_val===""){
      statusChanged.splice(i,1);
    }
  }
  return statusChanged;
}

export function getDealRcvdLogRmk(msg, activityLog, cmdtypair) {
  var obj = {};
  obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
  var dec = getDecimal(msg.IID);
  let remark = "";
  remark = "Trade request received: ";
  //remark=remark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
  ? "BUY"
  : "SELL") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
  remark = remark + " ";
  remark = remark + (msg.SC !== undefined
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @";
  remark = remark + " ";
  remark = remark + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0");
  remark = remark + " ";
  remark = remark + (msg.ST !== undefined
    ? msg.ST
    : "");
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  activityLog.unshift(obj);
  return activityLog;
}

export function getRejectedDealLogRemark(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
  let remark = "";
  if(msg.STATUS === -2 || msg.STATUS === - 1){
    remark = remark + "Trade unsuccessful. Margin levels are insufficient: ";
  } else {
    remark = remark + "Your trade request was unsuccessful: ";
  }
  //remark=remark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
  ? "BUY"
  : "SELL") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0") + " "
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getConfirmedDealLogRemark(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
  let remark = "";
  remark = msg.APSO===true ? "Square-Off Trade: " : "Trade confirmed: "
  //remark=reamark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BOUGHT"
    : "SOLD") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "]";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark + " (Comments: " + msg.RMK + ")";
  if (msg?.PDQ && Number(msg.PDQ) > 0) {
    remark = remark + "; Rejected Qty: " + (Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC ? msg.SC : "");
  }
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getPartialRejectedLogRemark(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);

  let remark = "";
  remark = "Your trade request has been partially rejected: ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
  ? "BUY"
  : "SELL") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0") + " ";
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

const updatePhysicalDeliveryActivity = (msg, activityLog) => {

  const item = Object.assign([], activityLog);
  const obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = msg.DRN ? msg.DRN : "";

  const userDetail = JSON.parse(localStorage.getItem('userDetail'));
  const sysBasedUnit = cleanUnitText(userDetail.CompanyBaseName);

  const {
    BCM,
    AD,
    AC,
    CMDTY,
    TOTAL_FC_PAMT,
    TOTAL_GQ,
    ADD_CHARGES,
    UCD,
    RMK,
    ADD_RMK,
    STOCK_QTY_FORMAT,
    STOCK_QTY_ROUND,
    STOCK_RATE_FORMAT,
    STOCK_RATE_ROUND,
    CURRENCY
  } = msg;

  const {
    PHYSICAL_DELIVERY_DELIVERED,
    PHYSICAL_DELIVERY_REQUEST_RECEIVED,
    PHYSICAL_DELIVERY_REQUEST_PLACED,
    PHYSICAL_DELIVERY_REQUEST_CANCELLED,
    PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL
  } = appConstants;

  let baseRemark = "";
  let suffixRemark = "";
  let comments = ""

   const qtyMinMax = getMinMaxFractionDigits(STOCK_QTY_FORMAT || '#,##0.000');
   const rateMinMax = getMinMaxFractionDigits(STOCK_RATE_FORMAT || '#,##0.000');
   const qtyRoundOff = STOCK_QTY_ROUND ?? 3;
   const rateRoundOff = STOCK_RATE_ROUND ?? 2;

   const formattedTotalPamt = TOTAL_FC_PAMT && getFormattedRate(TOTAL_FC_PAMT, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff);
   const currency = CURRENCY || "USD";
   const formattedAddCharges = ADD_CHARGES && getFormattedRate(ADD_CHARGES, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff);
   const formattedTotalGQ = TOTAL_GQ && getFormattedRate(TOTAL_GQ, qtyMinMax.minimumFractionDigits, qtyMinMax.maximumFractionDigits, true, qtyRoundOff);

  switch (BCM) {
    case PHYSICAL_DELIVERY_REQUEST_PLACED:
      baseRemark = "Delivery Request Placed: ";
      suffixRemark = userDetail.premiumChargedOnDelivery ? "" : `; Premium charged: ${formattedTotalPamt} ${currency}.`;
      comments = RMK ? ` (Comments: ${RMK})` : "";
      break;

    case PHYSICAL_DELIVERY_REQUEST_RECEIVED:
      baseRemark = "Delivery Request Received: ";
      comments = RMK ? ` (Comments: ${RMK})` : "";
      break;

    case PHYSICAL_DELIVERY_REQUEST_CANCELLED:
      baseRemark = "Delivery Request Cancelled: ";
      suffixRemark = `; Cancellation charges: ${formattedAddCharges} ${currency}.`;
      break;

    case PHYSICAL_DELIVERY_DELIVERED:
      baseRemark = "Delivery Request Processed: ";
      suffixRemark = `; Premium charged: ${formattedTotalPamt} ${currency}.`;
      comments = ADD_RMK ? ` (Comments: ${ADD_RMK})` : "";
      break;

    case PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL:
      baseRemark = "Delivery Request Placement Unsuccessful. ";
      suffixRemark = generatePhysicalDeliveyMarginCheckFailSuffix(msg)
      break;

    default:
      baseRemark = "";
  }

  if (BCM === PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL) {
    obj.remark = baseRemark + suffixRemark
  } else {
    obj.remark = `${baseRemark}${formattedTotalGQ} ${sysBasedUnit} ${CMDTY} for ${AD} [${UCD}]${suffixRemark} ${comments}`;
  }

  item.unshift(obj);
  return item;
}

export function getLimitOrderReqRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let remark = "";
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Order request received: " ;
  } else if (msg.OMT === appConstants.MODORD) {
    remark = remark + "Modify Order request received: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + "Cancel Order request received: ";
  }
  /*if(msg.SC === "1"){
    msg.SC = "";
  }*/
  remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL")+ " " :
    (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "STOP BUY"
      : "STOP SELL")+ " ");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
    remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
    (parseInt(msg.VT) === appConstants.DAY? "DAY":parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat):  "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getLimitOrderreject(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let remark = "";
  if(msg.STATUS === -2 || msg.STATUS === - 1){
    remark = remark + "Order unsuccessful. Margin levels are insufficient: ";
  } else {
    remark = remark + "Your order request was unsuccessful: ";
  }
  remark = remark + (msg.OT === 2 || msg.OT === 4  ? (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL")+ " " :
    (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "STOP BUY"
      : "STOP SELL")+ " ");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
   (parseInt(msg.VT) === appConstants.DAY? "DAY" :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getFixingOrderReject(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD ? msg.NOD : "");
  let remark = "";
  if(msg.OMT === 2){
    remark = remark + "Your Modify Fixing Order request was unsuccessful: " ;
  }else if(msg.OMT === 6){
    remark = remark + "Your Cancel Fixing Order request was unsuccessful: " ;
  }else if(msg.OMT === 7){
    remark = remark + "Your Fixing Order request was unsuccessful: " ;
  }else if (msg.OMT === 1) {
    remark = remark + "Your Fixing Order request was unsuccessful: " ;
  }
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC ? msg.SC : "");
  remark = remark + " " + cmdtypair;
  remark += " "+"@"+" " +msg.FN;
  //remark = remark + (msg.ST ? msg.ST : "");

  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getLimitOrderBrkreject(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let remark = "";
  remark = remark + "Your Order request was unsuccessful: ";
  remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL")+ " " :
    (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "STOP BUY"
      : "STOP SELL")+ " ");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
    (parseInt(msg.VT) === appConstants.DAY ? "DAY": parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat):"GTC"));
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getLimitOrderPlcRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  /*if(msg.SC==="1"){
    msg.SC = "";
  }*/
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let remark = "";
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Order Placed: ";
  } else if (msg.OMT === appConstants.MODORD) {
    remark = remark + "Order Modified: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + "Order Cancelled: ";
  }
  remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL")+ " " :
    (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "STOP BUY"
      : "STOP SELL")+ " ");
  if (msg.OMT === appConstants.CANCELORD) {
    let TFQ = (msg.TFQ !== undefined ? msg.TFQ : 0 );
    let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
      remark =remark + " " +(Number(parseFloat(showQty) - parseFloat(TFQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
 }
  else{
 remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
 }
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
     (parseInt(msg.VT) === appConstants.DAY? "DAY"
     :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getFixingOrderReqRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.DN
    ? msg.DN
    : "");
  let remark = "";
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Fixing Order request received: ";
  } else if (msg.OMT === appConstants.MODORD) {
    remark = remark + "Modify Fixing Order request received: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + " Cancel Fixing Order request received: ";
  }
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark += " "+"@"+" " +msg.FN;
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getFixingOrderPlcRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.DN
    ? msg.DN
    : "");
  let remark = "";
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Fixing Order Placed: ";
  } else if (msg.OMT === appConstants.MODORD) {
    remark = remark + "Fixing Order Modified: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + "Fixing Order Cancelled: ";
  }
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL") + " ";
  remark = remark + " " +(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark += " "+"@"+" " +msg.FN;
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getFixingOrderFillRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var dec = getDecimal(msg.IID);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.DN
    ? msg.DN
    : "");
  let remark = "";
  remark = remark + "Fixing Order Filled: ";
  remark = remark + "(" + (msg.FN
    ? msg.FN
    : "") + ") "
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BOUGHT"
    : "SOLD") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @";
  remark = remark + " ";
  remark = remark + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : 0) + " ";
  if(msg.NOD!==undefined && msg.NOD!==""){
  	remark = remark + " ("+msg.NOD+"), ";
  	}
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark +" ["+ msg.UCD + "] ";
  if(msg.RMK===undefined){
    msg.RMK="";
  }
  if(msg.RMK!=="" && msg.RMK!==" ")
  remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getInvalidCheck(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.OrderNo
    ? msg.OrderNo
    : "");
  let remark = "";
  // if (msg.OMT === appConstants.NEWORD) {
  //   remark = remark + "Order unsuccessful. ";
  // } else if (msg.OMT === appConstants.MODORD) {
  //   remark = remark + "Modify Order unsuccessful. ";
  // } else if (msg.OMT === appConstants.CANCELORD) {
  //   remark = remark + " Cancel Order unsuccessful. ";
  // }
  remark = remark + "Invalid Request: Trade request rejected because of invalid parameters. Please login and try again";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function getLmtExpLog(msg, activityLog, cmdtypair){
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
    let remark = "";
    let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
    remark = remark + "Order Expired: ";
    remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL")+ " " :
      (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "STOP BUY"
        : "STOP SELL")+ " ");
    remark = remark + " " + (Number(parseFloat(showQty)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
    remark = remark + " " + (msg.SC
      ? msg.SC
      : "");
    remark = remark + " " + cmdtypair;
    remark = remark + " @" + " " + (msg.R
      ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
      : "0") + " ";
    remark = remark + (msg.ST
      ? msg.ST
      : "");
    remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
       (parseInt(msg.VT) === appConstants.DAY? "DAY"
        : parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat):"GTC"));

    if (msg.AC)
      remark = remark + " for " + msg.AD;
      remark = remark +" ["+ msg.UCD + "] ";
      if(msg.RMK===undefined){
        msg.RMK="";
      }
      if(msg.RMK!=="" && msg.RMK!==" ")
      remark = remark +" (Comments: "+msg.RMK + ") ";
    obj.remark = remark;
    item.unshift(obj);
    return item;
}

export function getLmtOrderFillRecd(msg, activityLog, cmdtypair){
  // console.log("msg  "+ JSON.stringify(msg));
try{
  const item = Object.assign([], activityLog);
//  let qty=msg.OS==="F" ? msg.PQ : msg.FNCQ ;
  var obj = {};
  var status =(msg.OMT === 10 || msg.OMT=== 5 ? "Order Filled:" :"Order Partially Filled:");
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.DN
    ? msg.DN
    : "");
  let remark = "";
//  remark = remark + status+": " + msg.UCD + " ";
  remark = remark + status+ " ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BOUGHT"
    : "SOLD") + " ";
  remark = remark + " " +(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @" + " " + (parseInt(msg.OT) === 3 && msg.FCP ? (Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) : (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))) + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
     (parseInt(msg.VT) === appConstants.DAY? "DAY"
     :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark=remark + " ( "+msg.NOD+" )";
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  item.unshift(obj);
  return item;
}catch(e){console.log(e)}
}

export function activityuserLoggedIn(msg, activityLog) {
  if (msg.BCM === appConstants.TRD_LOGIN) {
    var obj = {};
    obj.det = moment().format(appConstants.actTimeDateTimeFormatter);
    obj.docNo = "";
    let remark = msg.MSG;
    obj.remark = remark;
    activityLog.unshift(obj);
    localStorage.setItem('activityLog', JSON.stringify(activityLog));
    return activityLog;
  }
}

export function getOpenPosDealRejectRmk(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  const COMM2 = item1.C === 2 ? (" "+item1.D2) :"";
  const fixingOrderType = (msg.OT).toString() === '4';
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD ? msg.NOD : "");

  let remark = "";
  if(msg.OT==1){
    remark = remark + "Trade unsuccessful. ";
  } else {
    if (msg.OMT === 2) {
      remark = remark + "Modify unsuccessful. ";
    } else if (fixingOrderType) {
      remark = remark + "Fixing Order unsuccessful. "
    } else {
      remark = remark + " Order unsuccessful. ";
    }
  }

  switch (msg.STATUS) {
    case appConstants.NOT_ENOUGH_FUND_TO_BUY:
      remark=remark+ "Not enough funds to Buy" +COMM2+ ".";
      break;
    case appConstants.NOT_ENOUGH_STK_POSITION_TO_SELL:
      remark=remark+ "Not enough position to Sell" +COMM2+ ".";
      break;
    default:
      remark=remark+ "Please try again. ";
      break;
  }

  obj.remark = remark;
  item.unshift(obj);
  return item;
}

export function actLogGenerator(msg, activityLog) {
  let cmdtypair;
  const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  cmdtypair = item.ID;
  switch (msg.BCM) {
    case appConstants.INITIAL_CHECKS_FAILED:
    case appConstants.MARGIN_CHECKS_FAILED:
      var obj = marginCheckNotification(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj); //dispatch(break;
    case appConstants.TRADE_REQUEST_RECEIVED:
      var obj = getDealRcvdLogRmk(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.TRADE_REQUEST_REJCTED:
      var obj = getRejectedDealLogRemark(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.TRADE_REQUEST_CONFIRMED:
      var obj = getConfirmedDealLogRemark(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_REQ_RECD:
      var obj = getLimitOrderReqRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORDER_REQUEST_REJECT:
      var obj = getLimitOrderreject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.BROKER_ORDER_MANUAL_CANCEL:
      var obj = getLimitOrderBrkreject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.REQUEST_REJECT:
      var obj = getLimitOrderreject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
    break;
    case appConstants.ORD_PLACED:
      var obj = getLimitOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_REQ_RECD:
      var obj = getFixingOrderReqRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_PLACED:
      var obj = getFixingOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.MODIFY_REQ_RECD:
      var obj=getLimitOrderReqRecd(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.ORD_CANCEL_REQUEST:
      var obj=getLimitOrderReqRecd(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.ORD_CANCEL:
    case appConstants.SYNTHETIC_ORDER_CANCELLED:
      var obj=getLimitOrderPlcRecd(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.ORD_MODIFIED:
      var obj = getLimitOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_MODIFY_REJECT:
      var obj = getLimitOrderreject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_MOD_REQ_RECD:
      var obj = getFixingOrderReqRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_MODIFIED:
      var obj = getFixingOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_CANC_REQ_RECD:
      var obj = getFixingOrderReqRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_CANCELLED:
      var obj = getFixingOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_MANUAL_FILL:
      var obj=getFixingOrderFillRecd(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.FIXING_ORDER_REJECTED:
    case appConstants.FIXING_ORDER_MODIFY_OR_CANCEL_REJECTED:
    case appConstants.FIXING_REQUEST_REJCTED:
      var obj = getFixingOrderReject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_UNHEDGE_FILL:
      var obj=getLmtOrderFillRecd(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.ORDER_UNHEDGE_EXPIRED:
      var obj=getLmtExpLog(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.ORDER_EXPIRED:
      var obj=getLmtExpLog(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.ORD_HEDGE_FILL:
      var obj=getLmtOrderFillRecd(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.ORD_PARTIAL_FILL:
      var obj = cancelPartialFilled(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.INVALID_CHECK:
      var obj = getInvalidCheck(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.FIXING_ORDER_FILLED:
      var obj=getFixingOrderFillRecd(msg,activityLog,cmdtypair);
      localStorage.setItem('activityLog',JSON.stringify(obj));
      return(obj);
      break;
    case appConstants.OPEN_POSITION_CHECKS_FAILED:
      var obj = getOpenPosDealRejectRmk(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    default:
      localStorage.setItem('activityLog', JSON.stringify(activityLog));
      return (activityLog);
  }
}

export function physicalOrderCnfrmMsgGenerator(msg, physicalDeliveryOrdCnfrmMsg) {
  const userDetails = JSON.parse(localStorage.getItem('userDetail'));
  if (msg.platform !== "Desktop") {
    if (userDetails.UID !== msg.UID) {
      localStorage.setItem('physicalDeliveryOrdCnfrmMsg', JSON.stringify(physicalDeliveryOrdCnfrmMsg));
      return physicalDeliveryOrdCnfrmMsg;
    }
  }

  const qtyMinMax = getMinMaxFractionDigits(msg.STOCK_QTY_FORMAT || '#,##0.000');
  const qtyRoundOff = msg.STOCK_QTY_ROUND ?? 3;
  const formattedTotalGQ = msg.TOTAL_GQ && getFormattedRate(msg.TOTAL_GQ, qtyMinMax.minimumFractionDigits, qtyMinMax.maximumFractionDigits, true, qtyRoundOff);

  // Generate confirmation message for physical delivery

  if (msg.BCM === appConstants.PHYSICAL_DELIVERY_REQUEST_PLACED) {
    const obj = {};
    obj.headerTitle = "Success";
    obj.remark1 = `Delivery request ${msg.DN} placed successfully for ${formattedTotalGQ} ${cleanUnitText(userDetails.CompanyBaseName)} ${msg.CMDTY}.`;
    obj.remark2 = `Please check Pending Requests tab to view more details.`;
    obj.ID = msg.TRID;
    localStorage.setItem('physicalDeliveryOrdCnfrmMsg', JSON.stringify(obj));
    return obj;
  }

  if (msg.BCM === appConstants.PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL) {
    const obj = {};
    obj.headerTitle = "Delivery";
    obj.remark1 = "Delivery Request Placement Unsuccessful. " + generatePhysicalDeliveyMarginCheckFailSuffix(msg);
    obj.ID = msg?.TRID ? msg.TRID : null;
    localStorage.setItem('physicalDeliveryOrdCnfrmMsg', JSON.stringify(obj));
    return obj;
  }
  localStorage.setItem('physicalDeliveryOrdCnfrmMsg', JSON.stringify(physicalDeliveryOrdCnfrmMsg));
  return physicalDeliveryOrdCnfrmMsg;

}

export function ordcnfrmsgGenerator(msg, ordcnfrmsg) {
  if(msg.platform !=="Desktop"){
    if(JSON.parse(localStorage.getItem("userDetail")).UID!=msg.UID){
      localStorage.setItem('ordcnfrmsg', JSON.stringify(ordcnfrmsg));
      return ordcnfrmsg;
    }
    return ordcnfrmsg;
  }else {
    if (msg.BCM === appConstants.TRADE_REQUEST_CONFIRMED) {
    var obj = {};
    var dec = getDecimal(msg.IID);
    const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    let metal;
    let curr;
  //  for (let index = 0; index < item.length; index++) {
    //  if (item[index].I === msg.IID) {
        metal = item.D1;
        curr = item.D2;
  //      break;
  //    }
  //  }
    let remark1 = "";
    let remark2 = "";
    let rejectedRemark = "";
    
    if (msg?.PDQ && Number(msg.PDQ) > 0) {
      rejectedRemark = rejectedRemark + "REJECTED QTY: " + (Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC ? msg.SC : "");
    }

    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark1 = "BOUGHT" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + " @" + " " + (msg.R
        ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
        : "0") + " ";
      remark2 = "SOLD" +
        " " + curr + " " + (msg.V
        ? (Number(parseFloat(msg.V)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF }))
        : "0");
    } else {
      remark2 = "BOUGHT" +
        " " + curr + " " + (msg.V
        ? (Number(parseFloat(msg.V)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF }))
        : "0");
      remark1 = "SOLD" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + " @" + " " + (msg.R
        ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
        : "0");
    }

    obj.remark1 = remark1;
    obj.remark2 = remark2;
    obj.rejectedRemark = rejectedRemark;
    obj.IID = msg.IID;
    obj.CTID = msg.CTID;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  } else if (msg.BCM === appConstants.TRADE_REQUEST_REJCTED || msg.BCM === appConstants.FIXING_REQUEST_REJCTED || msg.BCM === appConstants.OPEN_POSITION_CHECKS_FAILED) {
    var obj = {};  
    const orderType = msg.OT == 1 ? "trade" : "order"
    let remark1 = `Your ${orderType} request was unsuccessful. Please see the Activity Log for details.`;
    let remark2 = "";
    obj.remark1 = remark1;
    obj.remark2 = remark2;
    obj.headerTitle = msg.OT === 4 ? "Fixing Order" : "Limit Order";
    obj.CTID = msg.CTID;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  } else if (msg.BCM === appConstants.MARGIN_CHECKS_FAILED || msg.BCM === appConstants.INITIAL_CHECKS_FAILED ) {
    var obj = {};
    obj.headerTitle = msg.OT === 4 ? "Fixing Order" : "Limit Order";
    obj.CTID = msg.CTID;
    const orderType = msg.OT == 1 ? "trade" : "order"
    obj.remark1 = `Your ${orderType} request was unsuccessful. Please see the Activity Log for details.`;
    obj.remark2 = "";
    obj.IID = msg.IID;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  } else if (msg.BCM === appConstants.INVALID_CHECK) {
    var obj = {};
    let remark1 = "";
    let remark2 = "";
    let headerTitle="Alert";
    obj.CTID = msg.CTID;
    obj.remark1 = "Trade request rejected because of invalid parameters. Please login and try again";
    obj.remark2 = "";
    obj.IID = msg.IID;
    obj.headerTitle = headerTitle;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  } else if (appConstants.FIXING_ORDER_PLACED === msg.BCM) {
    var obj = {};
    const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    let metal = item.D1;
    let curr = item.D2;
    let cmdtyDesc=item.ID;
    let remark1 = "";
    let remark2 = "";
    let headerTitle="Fixing Order Placed";
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      //remark1="Order Placed";
      remark2 ="Buy" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + cmdtyDesc + " "+ "@ " + " "+msg.FN + " ";
    } else {
      //remark1="Order Placed";
      remark2 ="Sell" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + cmdtyDesc  + " "+ "@ " + " "+ msg.FN + " ";
    }
    obj.CTID = msg.CTID;
    obj.remark1 = remark1;
    obj.remark2 = remark2;
    obj.IID = msg.IID;
    obj.headerTitle = headerTitle;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  }else if(appConstants.ORD_PLACED === msg.BCM){
    var obj = {};
    var dec = getDecimal(msg.IID);
    const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    let metal;
    let curr;
  //  let isCustInst = item.C !== 32 ? false : true;
    //for (let index = 0; index < item.length; index++) {
    //  if (item[index].I === msg.IID) {
        metal = item.D1;
        curr = item.D2;
  //      break;
  //    }
  //  }
    let cmdtyDesc = item.ID;
    let remark1 = "";
    let remark2 = "";
    let headerTitle="Order Placed";
    remark1 = (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL")+ " " :
      (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "STOP BUY"
        : "STOP SELL")+ " ");

    // if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
    //   /*if(msg.SC === "1"){
    //     msg.SC = "";
    //   }*/
    //   //remark1 = "Order Placed "
    //   remark1 =  "Buy" +
    //     " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }))+ " " + (msg.SC
    //     ? msg.SC
    //     : "") + " " +  metal + "/" + curr + " @" + " " + (msg.R
    //     ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    //     : "0") + " ";
    // } else {
    //   //remark1 = "Order Placed"
    //   remark1 = "Sell" +
    //
    //
    // }
    remark1= remark1 +  " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC
      : "") + " "+ cmdtyDesc + " @" + " " + (msg.R
      ? (Number((msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
      : "0") + " ";
    remark1 = remark1 + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
     (parseInt(msg.VT) === appConstants.DAY? "DAY" :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC")) + ".";
    obj.remark1 = remark1;
    obj.remark2 = remark2;
    obj.headerTitle= headerTitle;
    obj.IID = msg.IID;
    obj.CTID = msg.CTID;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  }
  else if(appConstants.DEAL_CONFM=== msg.BCM){
    var obj = {};
    let remark1 = "Your trade request is in progress.";
    let remark2 = "";
    obj.remark1 = remark1;
    obj.remark2 = remark2;
    obj.CTID = msg.CTID;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  }
  else if (msg.BCM === appConstants.ORDER_REQUEST_REJECT || msg.BCM === appConstants.BROKER_ORDER_MANUAL_CANCEL) {
    var obj = {};
    let remark1 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
    let remark2 = "";
    obj.remark1 = remark1;
    obj.remark2 = remark2;
    obj.CTID = msg.CTID;
    localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
    return obj;
  } else if (msg.BCM === appConstants.TRADE_REQUEST_RECEIVED) {
    localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
    return ordcnfrmsg;
  }else if (msg.BCM === appConstants.ORD_REQ_RECD) {
    localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
    return ordcnfrmsg;
  }else if (msg.BCM === appConstants.FIXING_ORDER_REQ_RECD) {
    localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
    return ordcnfrmsg;
  }
  else {
    localStorage.setItem('ordcnfrmsg', JSON.stringify(ordcnfrmsg));
    return ordcnfrmsg;
  }
}
  return ordcnfrmsg;
}

export function trdeBookSet(msg, tradeBook) {
 //const item = Object.assign([], tradeBook);
 let cmdtypair;
 var dec = getDecimal(msg.IID);
 const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
// for (let index = 0; index < item1.length; index++) {
//   if (item1[index].I === msg.IID) {
     cmdtypair = item1.ID
//     break;
//   }
 //}
 var tradeBookArr = [];
 if (tradeBook){
 if (tradeBook.tradeBookArray !== undefined) {
   if (tradeBook.tradeBookArray.length !== 0) {
     tradeBookArr = tradeBook.tradeBookArray;
   }
 }
 }
 if (msg.BCM === appConstants.TRADE_REQUEST_CONFIRMED) {
   var obj = {
     'eventTime': moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter),
     'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
       ? "BUY"
       : "SELL"),
     'cmdtyPair': cmdtypair,
     'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
     'qtyType': (msg.SC
       ? msg.SC
       : ""),
     'rate': (msg.R
       ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
       : "0"),
     'docNo': (msg.NFD
       ? msg.NFD
       : ""),
     'valDate': moment(msg.VD).format(appConstants.rptDateFormat),
     'user':msg.UCD,
     'accDescription': msg.AD,
     'comments': msg.RMK,
     'cmdtyId': msg.IID
   };
   tradeBookArr.unshift(obj);
   tradeBook.tradeBookArray=tradeBookArr;
   tradeBook.randomNo = Math.floor((Math.random() * 10) + 1);
   let openedWidgets = localStorage.getItem('openedWidgets');
   let flag= 0;
   if (openedWidgets )
   {
     JSON.parse(openedWidgets).map((widget) => {
       if (widget.substring(0, 16) === "OutstandingOrder") {
         flag=1;
       }
     })
   }
   if(flag === 1){
     localStorage.setItem('tradeBook', JSON.stringify(tradeBook));
   }
   return Object.assign([], tradeBook);
 }else {
   let openedWidgets = localStorage.getItem('openedWidgets');
   let flag= 0;
   if (openedWidgets )
   {
     JSON.parse(openedWidgets).map((widget) => {
       if (widget.substring(0, 16) === "OutstandingOrder") {
         flag=1;
       }
     })
   }
   if(flag === 1){
     localStorage.setItem('tradeBook', JSON.stringify(tradeBook));
   }
   return Object.assign([], tradeBook);
 }
}

export function setRequestRejectModal(msg,requestRejectModal){
  localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
  var obj={};
  if(msg.BCM===appConstants.INITIAL_CHECKS_FAILED || msg.BCM===appConstants.MARGIN_CHECKS_FAILED || msg.BCM=== appConstants.ORD_MODIFY_REJECT || msg.BCM===appConstants.ORD_PARTIAL_FILLED )
    {
      if(parseInt(msg.OMT)===2){
        obj.mdflag=true;
        //if(parseInt(msg.OT)===2){
            obj.title=msg.OT === 4 ? "Modify Fixing Order":"Modify Limit Order";
        // }else if(parseInt(msg.OT)===5){
        //   obj.title="Modify Bmk Order";
        // }
        obj.msg="Your order request was unsuccessful. Please see the Activity Log for details.";
        obj.CTID = msg.CTID;
        obj.OMT=msg.OMT;
        obj.bcm=msg.BCM;
        obj.OT=msg.OT;
        requestRejectModal=obj;
        localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
      }

      if(parseInt(msg.OMT)===6){
        obj.mdflag=true;
        obj.title=msg.OT === 4 ? "Cancel Fixing Order":"Cancel Limit Order";
        obj.msg="Your order request was unsuccessful. Please see the Activity Log for details.";
        obj.CTID = msg.CTID;
        obj.bcm=msg.BCM;
        obj.OT=msg.OT;
        requestRejectModal=obj;
        localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
      }

    } else if( msg.BCM===appConstants.INVALID_CHECK){
      obj.mdflag=true;
      obj.title="Invalid Request";
      obj.msg="Trade request rejected because of invalid parameters. Please login and try again";
      obj.CTID = msg.CTID;
      obj.bcm=msg.BCM;
      obj.OT=msg.OT;
      requestRejectModal=obj;
      localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
    }
    return requestRejectModal
}

const closeReqRejectModal  = (requestRejectModal) => {
  var obj1 = {
    mdflag:false,
    title:"",
    msg:"",
    CTID:"",
    bcm:"",
    OT:""
  };
  localStorage.setItem('requestRejectModal',JSON.stringify(obj1));
  //localStorage.setItem('requestRejectModal',false);
  return obj1;
}

export function setLimitOrdBook(msg,lmObj){
  let cmdtypair;
  let rate;
  var dec = getDecimal(msg.IID);
  const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  //for (let index = 0; index < item1.length; index++) {
  //  if (item1[index].I === msg.IID) {
      cmdtypair = item1.ID;
      rate=(parseInt(msg.DT) === appConstants.TRADER_BUY ? item1.ask:item1.bid);
    //  break;
  //  }
//  }
  var templmtArray = [];
  var lmtOrdArr = [];
  lmtOrdArr = lmObj.lmtOrdersRows;
  if (lmObj.outstandingLm){
  if (lmObj.outstandingLm.outstandingLmArr !== undefined) {
    if (lmObj.outstandingLm.outstandingLmArr.length !== 0) {
      templmtArray = lmObj.outstandingLm.outstandingLmArr;
    }
  }
  }

  if (lmObj.limitOrdMap === null) {
    var temMap = new Map();
  } else {
    temMap = lmObj.limitOrdMap;
  }
  if (appConstants.ORD_PLACED === msg.BCM) {
    if (msg.DRMK === undefined) {
      msg.DRMK = "";
    }
    var obj = {
      id: msg.TRID,
      'placedBy':msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'cmdtyPair': cmdtypair,
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'outstanding': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'filled': (Number(parseFloat('0')).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'price' : (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'validity': (parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT,
      'orderType':msg.OT
    };

    var obj2 = {
      id: msg.TRID,
      'placedBy':msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Outstanding',
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':'',
      'accCode': msg.AC,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT,
      'orderType':msg.OT
    };
    var obj1 = {
      'id': msg.TRID,
      'placedBy':msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'OMT': msg.OMT,
      'PCT': msg.PCT,
      'DRMK': msg.DRMK,
       'HSE':msg.HSE,
      'OR': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'OSC': msg.SC,
      'wk':msg.PQ,
      'FQ':0.000,
      'OMC': parseInt(msg.OMC) + 1,
      'VT' :msg.VT,
      'BID':msg.BID,
      'VD':msg.VD,
      'TIME':msg.VTE,
      'OTIME': msg.OLDVTE,
      'CTID': msg.CTID,
      'cmdtyId': msg.IID,
      'DT':msg.DT,
      'orderType':msg.OT
    };

    templmtArray.unshift(obj);
    lmtOrdArr.unshift(obj2);
    temMap.set(msg.NOD, obj1);
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else if (appConstants.ORD_MODIFIED === msg.BCM) {
    if (msg.DRMK === undefined) {
      msg.DRMK = "";
    }
    if(msg.RMK=== undefined){
      msg.RMK="";
    }
    var obj = {
      id: msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'cmdtyPair': cmdtypair,
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'outstanding': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'filled': parseFloat(0.000),
      'price' : (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT,
      'orderType':msg.OT
    };
    var obj2 = {
      id: msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Outstanding',
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':'',
      'accCode': msg.AC,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT,
      'orderType':msg.OT
    };
    var obj1 = {
      'id': msg.TRID,
      'placedBy': msg.UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'OMT': msg.OMT,
      'PCT': msg.PCT,
      'DRMK': msg.DRMK,
      'OR':(Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'OSC': msg.SC,
      'wk':msg.PQ,
      'FQ':msg.PQ,
      'OMC': parseInt(msg.OMC) + 1,
      'VT' :msg.VT,
      'BID':msg.BID,
      'HSE':msg.HSE,
      'VD':msg.VD,
      'TIME':msg.VTE,
      'OTIME': msg.OLDVTE,
      'CTID': msg.CTID,
      'cmdtyId': msg.IID,
      'DT':msg.DT,
      'orderType':msg.OT
    };

    temMap.set(msg.NOD, obj1);
    for (let i = 0; i < templmtArray.length; i++) {
      if (templmtArray[i].orderNo === msg.NOD) {
        templmtArray[i] = obj;
        break;
      }
    }
    for (let i = 0; i < lmtOrdArr.length; i++) {
      if(lmtOrdArr[i].orderNo === msg.NOD){
        lmtOrdArr[i] = obj2;
        break;
      }
    }

    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }
  else if(appConstants.HEGDGE_SETT_CHNG === msg.BCM){
    var tempobj=temMap.get(msg.NOD);
    tempobj.id=msg.TRID;
    if (msg.BID !== undefined) {
      tempobj.BID=msg.BID;
    }
    temMap.set(msg.NOD,tempobj);
    lmObj.limitOrdMap = temMap;
  } 
  else if(appConstants.ONLY_MRKUP_MODIFIED === msg.BCM){
    var tempobj=temMap.get(msg.NOD);
    tempobj.id=msg.TRID; // updating TRID only to sync with BE updated transaction id
    temMap.set(msg.NOD,tempobj);
    lmObj.limitOrdMap = temMap;
  }
   else if (appConstants.ORD_CANCEL === msg.BCM || appConstants.SYNTHETIC_ORDER_CANCELLED === msg.BCM) {
    var templmtArrayCancel = [];
    if (lmObj.lmCancellOrd.lmCancellOrdArr !== undefined) {
      if (lmObj.lmCancellOrd.lmCancellOrdArr !== 0) {
        templmtArrayCancel = lmObj.lmCancellOrd.lmCancellOrdArr;
      }
    }
    for (let i = 0; i < templmtArray.length; i++) {
      if (templmtArray[i].orderNo === msg.NOD) {
        templmtArray.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i < lmtOrdArr.length; i++) {
      if (lmtOrdArr[i].orderNo === msg.NOD && lmtOrdArr[i].status!=='Filled') {
        lmtOrdArr.splice(i, 1);
        break;
      }
    }
    temMap.delete(msg.NOD);
    let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
    var obj = {
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity': (Number(parseFloat((parseFloat(showQty)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'cancelledBy': msg.UCD,
      'accDescription':msg.AD,
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          :parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) : "GTC")),
      'orderNo': msg.NOD,
      'cmdtyId': msg.IID
    }

    var obj2 = {
      id: msg.ID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Cancelled',
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity':(Number(parseFloat(showQty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'cancelledBy': msg.UCD,
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          :parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) : "GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':'',
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': false
    };
    templmtArrayCancel.unshift(obj);
    lmtOrdArr.unshift(obj2);
    lmObj.lmCancellOrd.lmCancellOrdArr = templmtArrayCancel;
    lmObj.lmCancellOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }
  else if(appConstants.ORD_UNHEDGE_FILL === msg.BCM || appConstants.ORD_HEDGE_FILL=== msg.BCM){
    // console.log("ORD_HEDGE_FILL "+ JSON.stringify(msg));
    var templmtArrayFill = []
    if (lmObj.lmFillOrd.lmFillOrdArr !== undefined) {
      if (lmObj.lmFillOrd.lmFillOrdArr.length !== 0) {
        templmtArrayFill = lmObj.lmFillOrd.lmFillOrdArr;
      }
    }
    var lmtOrd=temMap.get(msg.NOD);
    if(msg.OMT!==4){
      for (let i = 0; i < templmtArray.length; i++) {
        if (templmtArray[i].orderNo === msg.NOD) {
          templmtArray.splice(i, 1);
          break;
        }
      }
      let flag=0;
      let qty;
      for (let i = 0; i < templmtArrayFill.length; i++) {
        if (templmtArrayFill[i].orderNo === msg.NOD) {
          flag=1;
            templmtArrayFill[i].quantity=(templmtArrayFill[i].quantity).replace(getSeparator(navigator.language,'decimal'),getSeparator('en-US','decimal'));
            templmtArrayFill[i].quantity=(templmtArrayFill[i].quantity).replace(getSeparator(navigator.language,'group'),"");
            qty=Number(parseFloat(templmtArrayFill[i].quantity) + parseFloat(msg.PQ)).toLocaleString(navigator.language, {minimumFractionDigits:3});
          templmtArrayFill.splice(i, 1);
          break;
        }
      }
    for (let i = 0; i < lmtOrdArr.length; i++) {
      if (lmtOrdArr[i].orderNo === msg.NOD && lmtOrdArr[i].status==="Outstanding") {
        lmtOrdArr.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i < lmtOrdArr.length; i++) {
          if (lmtOrdArr[i].orderNo === msg.NOD){
          if(msg.PDQ===0) {
            lmtOrdArr.splice(i, 1);
          }
            break;
          }
        }
    temMap.delete(msg.NOD);
    //let qty=msg.OS==="F" ? msg.PQ :msg.FCNQ;
    var obj = {
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity': flag===1? qty :(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': (parseInt(msg.OT) === 3 && msg.FCP ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
      'docNo': msg.DN,
      'orderNo': msg.NOD,
      'valDate': moment(msg.VD).format(appConstants.rptDateFormat),
      'comments': msg.RMK,
      'wk':msg.PDQ,
      'fq':msg.PQ,
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'cmdtyId': msg.IID
    };
    var obj2 = {
      id: msg.ID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Filled',
      'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL") :
        (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "STOP BUY"
          : "STOP SELL")),
      'cmdtyPair': cmdtypair,
      'quantity': flag===1? qty :(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate':(parseInt(msg.OT) === 3 && msg.FCP  ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
          : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':msg.DN,
      'accCode': msg.AC,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': false
    };
    lmtOrdArr.unshift(obj2);
    templmtArrayFill.unshift(obj);
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
    lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.lmtOrdersRows = lmtOrdArr;
  }
  else{
    let filled=0;
    let outstanding=0;
    let check=0;
    for (let i = 0; i < templmtArray.length; i++) {
      if (templmtArray[i].orderNo === msg.NOD) {
        templmtArray[i].quantity=parseFloat(msg.PDQ).toLocaleString(navigator.language, {minimumFractionDigits:3});
        outstanding=Number(templmtArray[i].quantity).toFixed(config.QuantityRoundOff);
        templmtArray[i].filled=parseFloat(templmtArray[i].filled)+parseFloat(msg.PQ);
        filled=templmtArray[i].filled;
        if(parseFloat(outstanding)===0){
          for (let i = 0; i < templmtArray.length; i++) {
            if (templmtArray[i].orderNo === msg.NOD) {
              templmtArray.splice(i, 1);
              break;
            }
          }
        }
        break;
      }
    }

    if(templmtArrayFill.length > 0){
      for (let i = 0; i < templmtArrayFill.length; i++) {
        if (templmtArrayFill[i].orderNo === msg.NOD) {
          templmtArrayFill[i].wk=parseFloat(msg.PDQ);
          templmtArrayFill[i].fq=parseFloat(templmtArrayFill[i].fq)+parseFloat(msg.PQ);
          templmtArrayFill[i].quantity= (Number(parseFloat(templmtArrayFill[i].fq)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff  }));
          let wk =Number(templmtArrayFill[i].wk).toFixed(config.QuantityRoundOff);
          for (let j = 0; j < lmtOrdArr.length; j++) {
            if (lmtOrdArr[j].orderNo === msg.NOD && lmtOrdArr[j].status==="Outstanding") {
              lmtOrdArr[j].quantity=parseFloat(msg.PDQ).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff});
              if(templmtArrayFill[i].wk===0 &&  lmtOrdArr[j].status==="Outstanding"){
                lmtOrdArr.splice(j, 1);
              }
              break;
            }
            if (lmtOrdArr[j].orderNo === msg.NOD && lmtOrdArr[j].status==="Partially Filled" || lmtOrdArr[j].status==="Filled") {
                lmtOrdArr[j].quantity=templmtArrayFill[i].quantity;
            }
          }
          check=1;
          break;
        }
      }

      if(check!==1)
      {
      var obj = {
          'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
          'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL") :
            (parseInt(msg.DT) === appConstants.TRADER_BUY
              ? "STOP BUY"
              : "STOP SELL")),
          'cmdtyPair': cmdtypair,
          'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff  })),
          'qtyType': msg.SC,
          'rate': (parseInt(msg.OT) === 3 && msg.FCP  ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }) : Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
          'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
              : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
          'docNo': msg.DN,
          'orderNo': msg.NOD,
          'valDate': moment(msg.VD).format(appConstants.rptDateFormat),
          'wk':outstanding,
          'fq':filled,
          'comments': msg.RMK,
          'accCode': msg.AC,
          'accDescription': msg.AD,
          'cmdtyId': msg.IID
        };
        var obj2 = {
          id: msg.ID,
          'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
          'status':msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled',
          'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL") :
            (parseInt(msg.DT) === appConstants.TRADER_BUY
              ? "STOP BUY"
              : "STOP SELL")),
          'cmdtyPair': cmdtypair,
          'quantity':(Number(parseFloat(filled)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff  })),
          'qtyType': msg.SC,
          'rate': (parseInt(msg.OT) === 3 && msg.FCP  ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }) : Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
          'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
              :parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) : "GTC")),
          'orderNo': (msg.NOD
            ? msg.NOD
            : ""),
          'docNo':msg.DN,
          'accCode': msg.AC,
          'accDescription':msg.AD,
          'comments': msg.RMK,
          'cmdtyId': msg.IID,
          'selectable': false
        };
        templmtArrayFill.unshift(obj);
        lmtOrdArr.unshift(obj2);
      }
    }
    else{
      var obj = {
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL") :
          (parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "STOP BUY"
            : "STOP SELL")),
        'cmdtyPair': cmdtypair,
        'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'qtyType': msg.SC,
        'rate': (parseInt(msg.OT) === 3 && msg.FCP  ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }) : Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
            :parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) : "GTC")),
        'docNo': msg.DN,
        'orderNo': msg.NOD,
        'valDate': moment(msg.VD).format(appConstants.rptDateFormat),
        'wk':outstanding,
        'fq':filled,
        'comments': msg.RMK,
        'accCode': msg.AC,
        'accDescription': msg.AD,
        'cmdtyId': msg.IID
      };
      var obj2 = {
        id: msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status':msg.OMT === 5 || msg.OMT ===10 ? 'Filled' : 'Partially Filled',
        'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL") :
          (parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "STOP BUY"
            : "STOP SELL")),
        'cmdtyPair': cmdtypair,
        'quantity': (Number(parseFloat(filled)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff  })),
        'qtyType': msg.SC,
        'rate': (parseInt(msg.OT) === 3 && msg.FCP  ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }) : Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
            : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
        'orderNo': (msg.NOD
          ? msg.NOD
          : ""),
        'docNo':msg.DN,
        'accCode': msg.AC,
        'accDescription':msg.AD,
        'comments': msg.RMK,
        'cmdtyId': msg.IID,
        'selectable': false
      };
      templmtArrayFill.unshift(obj);
      lmtOrdArr.unshift(obj2);

    }
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
    lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.lmtOrdersRows = lmtOrdArr;
  }
}else if(appConstants.ORDER_PARTIAL_FILL_CAN_EXP===msg.BCM){
  try{
  var lmtOrd=temMap.get(msg.NOD);
  // temMap.delete(msg.NOD);
  for (let i = 0; i < templmtArray.length; i++) {
    if (templmtArray[i].orderNo === msg.NOD) {
      templmtArray.splice(i, 1);
      break;
    }
  }
  for (let i = 0; i < lmtOrdArr.length; i++) {
    if (lmtOrdArr[i].orderNo === msg.NOD) {
      lmtOrdArr.splice(i, 1);
      break;
    }
  }
  var templmtArrayFill = []
  if (lmObj.lmFillOrd.lmFillOrdArr !== undefined) {
    if (lmObj.lmFillOrd.lmFillOrdArr.length !== 0) {
      var templmtArrayFill = lmObj.lmFillOrd.lmFillOrdArr;
    }
  }
  var obj = {
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'deal': (parseInt(msg.OT) === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL") :
      (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "STOP BUY"
        : "STOP SELL")),
    'cmdtyPair': cmdtypair,
    'quantity': (Number(parseFloat(msg.PQ)-parseFloat(msg.PCEQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
    'qtyType': msg.SC,
    'rate':(parseInt(msg.OT) === 3 && msg.FCP  ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
        : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC")),
    'docNo': msg.NFD,
    'orderNo': msg.NOD,
    'valDate': moment(msg.VD).format(appConstants.rptDateFormat),
    'wk':msg.PDQ,
    'fq':msg.PQ,
    'comments': msg.RMK,
    'accCode': msg.AC,
    'accDescription': msg.AD,
    'cmdtyId': msg.IID
  };
  var obj2 = {
    id: msg.ID,
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'status':'Filled',
    'deal': (parseInt(msg.OT) === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL") :
      (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "STOP BUY"
        : "STOP SELL")),
    'cmdtyPair': cmdtypair,
    'quantity': (Number(parseFloat(msg.PQ)-parseFloat(msg.PCEQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
    'qtyType': msg.SC,
    'rate':(parseInt(msg.OT) === 3 && msg.FCP  ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
        :parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) : "GTC")),
    'orderNo': (msg.NOD
      ? msg.NOD
      : ""),
    'docNo':msg.NFD,
    'accCode': msg.AC,
    'accDescription':msg.AD,
    'comments': msg.RMK,
    'cmdtyId': msg.IID,
    'selectable': false
  };
  templmtArrayFill.unshift(obj);
  lmtOrdArr.unshift(obj2);
  lmObj.limitOrdMap = temMap;
  lmObj.outstandingLm.outstandingLmArr = templmtArray;
  lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
  lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.lmtOrdersRows = lmtOrdArr;
}catch(e){console.log(e);}
}else if(appConstants.ORDER_EXPIRED===msg.BCM || appConstants.ORDER_UNHEDGE_EXPIRED===msg.BCM){
  //lmExpOrd:{lmExpOrdArr:[],randomNo:0},
  var templmtArrayExpire = [];
  if (lmObj.lmExpOrd.lmExpOrdArr !== undefined) {
    if (lmObj.lmExpOrd.lmExpOrdArr !== 0) {
      templmtArrayExpire = lmObj.lmExpOrd.lmExpOrdArr;
    }
  }
  for (let i = 0; i < templmtArray.length; i++) {
    if (templmtArray[i].orderNo === msg.NOD) {
      templmtArray.splice(i, 1);
      break;
    }
  }
  for (let i = 0; i < lmtOrdArr.length; i++) {
    if (lmtOrdArr[i].orderNo === msg.NOD && lmtOrdArr[i].status!=='Filled') {
      lmtOrdArr.splice(i, 1);
      break;
    }
  }
  temMap.delete(msg.NOD);
  let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
  var obj = {
    'placedBy': msg.P_UCD,
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL") :
      (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "STOP BUY"
        : "STOP SELL")),
    'cmdtyPair': cmdtypair,
    'quantity': (Number(parseFloat(showQty)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
    'qtyType': msg.SC,
    'rate': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
        :parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) : "GTC")),
    'orderNo': msg.NOD,
    'accDescription':msg.AD,
    'cmdtyId': msg.IID
  }
  var obj2 = {
    id: msg.ID,
    'placedBy': msg.P_UCD,
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'status':'Expired',
    'deal': (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL") :
      (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "STOP BUY"
        : "STOP SELL")),
    'cmdtyPair': cmdtypair,
    'quantity': (Number(parseFloat(showQty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
    'qtyType': msg.SC,
    'rate': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY"
        :parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) : "GTC")),
    'orderNo': (msg.NOD
      ? msg.NOD
      : ""),
    'docNo':'',
    'accDescription':msg.AD,
    'comments': msg.RMK,
    'cmdtyId': msg.IID,
    'selectable': false
  };
  templmtArrayExpire.unshift(obj);
  lmtOrdArr.unshift(obj2);
  lmObj.lmExpOrd.lmExpOrdArr = templmtArrayExpire;
  lmObj.lmExpOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.outstandingLm.outstandingLmArr = templmtArray;
  lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.limitOrdMap = temMap;
  lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.lmtOrdersRows = lmtOrdArr;
}
  let openedWidgets = localStorage.getItem('openedWidgets');
  let flag= 0;
  if (openedWidgets )
  {
    JSON.parse(openedWidgets).map((widget) => {
      if (widget.substring(0, 16) === "OutstandingOrder") {
        flag=1;
      }
    })
  }
  if(flag === 1){
    localStorage.setItem('limitOrdBook', JSON.stringify(lmObj));
  }
  //localStorage.setItem('outstandingLm', JSON.stringify(lmObj.outstandingLm));
  return lmObj;
}

export function limitFileeObj(msg, lmobj){
  var metal;
  var curr;
  var comm;
  var dec = getDecimal(msg.IID);
  const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  //let isCustInst = item.C !== 32 ? false : true;
  //var remark = "";
  //var remark2 = "";
  //for (let index = 0; index < item.length; index++) {
  //  if (item[index].I === msg.IID) {
      metal = item.D1;
      curr = item.D2;
      comm = item.B;
  //    break;
  //  }
//  }
  let cmdtyDesc =item.ID;
  if(msg.RMK===undefined){
    msg.RMK="";
  }
  if (msg.BCM === appConstants.ORD_HEDGE_FILL || msg.BCM === appConstants.ORD_UNHEDGE_FILL) {
    var remark = "";
    var remark2 ="";
    // stock code will be taken from API itself eg(msg.SC);
    var sc = msg.SC;
    /*if(parseInt(comm)===1){
      sc="";
    }else {
      sc="OZ";
    }*/
      //let qty=msg.OS==="F" ? msg.PQ : msg.FNCQ ;
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BOUGHT" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + sc + " " + cmdtyDesc + " @ " + (parseInt(msg.OT) === 3 && msg.FCP ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
         + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC"));
      if(msg.OMT === 4){
        // remark2 ="Outstanding Balance:" +" BUY" +
        //   " " + (Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + sc + " " + metal + "/" + curr + " @ " + (parseInt(msg.OT) === 3 && msg.FCP ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
        //    + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC"));
           remark2 =(Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + sc;
            }
    } else {
      remark = "SOLD" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + sc + " " + cmdtyDesc + " @ " + (parseInt(msg.OT) === 3 && msg.FCP ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
         + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC"));
      if(msg.OMT === 4){
        // remark2 ="Outstanding Balance:" +" SELL" +
        //   " " + (Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + sc + " " + metal + "/" + curr + " @ " + (parseInt(msg.OT) === 3 && msg.FCP ? Number(parseFloat(msg.FCP)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
        //   + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : parseInt(msg.VT) === appConstants.GTT ? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat) :"GTC"));
        //     }
        remark2 =(Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + sc;
            }
    }

    let orderStatus = (msg.OMT  !== 4 ? "FILLED" : "PARTIALLY FILLED");
     var obj = {
      flag: true,
      title: (parseInt(msg.OT) === 2?"Limit":"Stop"),
      eventType: orderStatus,
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      fncNo:msg.DN,
      trader: msg.UCD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2
    };
    return obj;
  } else if (msg.BCM === appConstants.ORD_MODIFIED) {
    var remark = "";
    var remark2 = "";
    var rmkOneParams = {type:"",pq:msg.PQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
    var rmkTwoParams = {type:"",opq:msg.OPQ,minFracDigit:config.QuantityRoundOff,sc:msg.OSC,metal:metal,curr:curr,qr:msg.OR,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,otime:msg.OLDVTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
   if(parseInt(msg.OT) === 2){
      if(parseInt(msg.DT) === 0){
        rmkOneParams.type = "SELL";
        rmkTwoParams.type = "SELL";
        var rmkData = executeModifyRemark(remark, rmkOneParams, remark2, rmkTwoParams);
        remark = rmkData.remark1;
        remark2 = rmkData.remark2;
      }else{
        rmkOneParams.type = "BUY";
        rmkTwoParams.type = "BUY";
        var rmkData = executeModifyRemark(remark, rmkOneParams, remark2, rmkTwoParams);
        remark = rmkData.remark1;
        remark2 = rmkData.remark2;
      }
    }else{
      if(parseInt(msg.DT) === 0){
        rmkOneParams.type = "STOP SELL";
        rmkTwoParams.type = "STOP SELL";
        var rmkData = executeModifyRemark(remark, rmkOneParams, remark2, rmkTwoParams);
        remark = rmkData.remark1;
        remark2 = rmkData.remark2;
      }else{
        rmkOneParams.type = "STOP BUY";
        rmkTwoParams.type = "STOP BUY";
        var rmkData = executeModifyRemark(remark, rmkOneParams, remark2, rmkTwoParams);
        remark = rmkData.remark1;
        remark2 = rmkData.remark2;
      }
    }
    /*if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      executeRemark();
      remark = "BUY" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
      remark2 = "Old: "+"BUY" +
        " " + (Number(parseFloat(msg.OPQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OR)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.OTIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
    } else {
      executeRemark();
      remark = "SELL" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " " + " @ " + (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
      remark2 = "Old: "+"SELL" +
        " " + (Number(parseFloat(msg.OPQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OR)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.OTIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
    }*/
    var obj = {
      flag: true,
      title: (parseInt(msg.OT) === 2?"Limit":"Stop"),
      eventType: "MODIFIED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      fncNo:"",
      trader: msg.UCD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2
    };
    return obj;
  }else if (msg.BCM === appConstants.ORDER_UNHEDGE_EXPIRED || msg.BCM === appConstants.ORDER_EXPIRED) {
    let remark = ""
    let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
    if(parseInt(msg.OT) === 2){
      if(parseInt(msg.DT) === 0){
       var rmkOneParams = {type:"SELL",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
        remark = executeCancelRemark(remark, rmkOneParams);
      }else{
     var rmkOneParams = {type:"BUY",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
        remark = executeCancelRemark(remark, rmkOneParams);
      }
    }else{
      if(parseInt(msg.DT) === 0){
     var rmkOneParams = {type:"STOP SELL",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
         remark = executeCancelRemark(remark, rmkOneParams);
      }else{
        var rmkOneParams = {type:"STOP BUY",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
        remark = executeCancelRemark(remark, rmkOneParams);
      }
    }
    /*if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
    } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD"+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
    }*/
    var obj = {
      flag: true,
      title: (parseInt(msg.OT) === 2?"Limit":"Stop"),
      eventType: "EXPIRED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      fncNo:"",
      trader: msg.UCD,
      comments:msg.RMK,
      remark: remark,
      remark2: ""
    };
    return obj;
  }else if (msg.BCM === appConstants.ORD_CANCEL) {
    let remark = "";
    let remark2 = "";
    let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
    if(parseInt(msg.OT) === 2){
      if(parseInt(msg.DT) === 0){
        var rmkOneParams = {type:"SELL",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
        remark = executeCancelRemark(remark, rmkOneParams);
      }else{
        var rmkOneParams = {type:"BUY",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
        remark = executeCancelRemark(remark, rmkOneParams);
      }
    }else{
      if(parseInt(msg.DT) === 0){
        var rmkOneParams = {type:"STOP SELL",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
        remark = executeCancelRemark(remark, rmkOneParams);
      }else{
        var rmkOneParams = {type:"STOP BUY",gq:showQty,tfq:msg.TFQ,minFracDigit:config.QuantityRoundOff,sc:msg.SC,metal:metal,curr:curr,r:msg.R,minFracDigit2:dec,vt:msg.VT,gtd:appConstants.GTD,time:msg.VTE,valGTTformat:appConstants.validityDateFormat,valDatform:appConstants.ymmdd,day:appConstants.DAY,cmdtyDesc:cmdtyDesc};
        remark = executeCancelRemark(remark, rmkOneParams);
      }
    }
    /*if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
    } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " " + " @ " + (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY" : "GTC"));
    }*/
    var obj = {
      flag: true,
      title: (parseInt(msg.OT) === 2?"Limit":"Stop"),
      eventType: "CANCELLED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      fncNo:"",
      trader: msg.UCD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2
    };
    return obj;
  }else {
    return lmobj;
  }
}

export function setFixingOrdBook(msg,fixObj){
  let cmdtypair;
  let rate;
  var dec = getDecimal(msg.IID);
  const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  cmdtypair = item1.ID;
  rate=(parseInt(msg.DT) === appConstants.TRADER_BUY ? item1.ask:item1.bid);
  var tempFixArray = [];
  var fixOrdArr = [];
  fixOrdArr = fixObj.fixOrdersRows;
  if (fixObj.outstandingFix){
    if (fixObj.outstandingFix.outstandingFixArr !== undefined) {
      if (fixObj.outstandingFix.outstandingFixArr.length !== 0) {
        tempFixArray = fixObj.outstandingFix.outstandingFixArr;
      }
    }
  }
  if (fixObj.fixingOrdMap === null) {
    var tempMap = new Map();
  } else {
    tempMap = fixObj.fixingOrdMap;
  }
  if (appConstants.FIXING_ORDER_PLACED === msg.BCM) {
    var obj = {
      id: msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'orderNo': (msg.DN
        ? msg.DN
        : ""),
      'cmdtyPair': cmdtypair,
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate' : (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT,
    };

    var obj2 = {
      id: msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Outstanding',
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': "",
      'orderNo': (msg.DN
        ? msg.DN
        : ""),
      'docNo':'',
      'accCode': msg.AC,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT,
    };
    var obj1 = {
      'id': msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'orderNo': (msg.DN
        ? msg.DN
        : ""),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'OMT': msg.OMT,
      'PCT': msg.PCT,
      'OR': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'OSC': msg.SC,
      'BID':msg.BID,
      'VD':msg.VD,
      'CTID': msg.CTID,
      'cmdtyId': msg.IID,
      'DT':msg.DT,
    };

    tempFixArray.unshift(obj);
    fixOrdArr.unshift(obj2);
    tempMap.set(msg.DN, obj1);
    fixObj.outstandingFix.outstandingFixArr = tempFixArray;
    fixObj.outstandingFix.randomNo = Math.floor((Math.random() * 1000000) + 1);
    fixObj.fixingOrdMap = tempMap;
    fixObj.fixOrdersRows = fixOrdArr;
    fixObj.randomNo = Math.floor((Math.random() * 1000000) + 1);

  }else if (appConstants.FIXING_ORDER_MODIFIED === msg.BCM) {
    if(msg.RMK=== undefined){
      msg.RMK="";
    }
    var obj = {
      id: msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'orderNo': (msg.NOD ? msg.NOD : ""),
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'cmdtyPair': cmdtypair,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL"),
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate' : (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT
    };
    var obj2 = {
      id: msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Outstanding',
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': "",
      'orderNo': (msg.NOD ? msg.NOD : ""),
      'docNo':'',
      'accCode': msg.AC,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': true,
      'DT':msg.DT
    };
    var obj1 = {
      'id': msg.TRID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL") ,
      'cmdtyPair': cmdtypair,
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'orderNo': (msg.NOD ? msg.NOD : ""),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'OMT': msg.OMT,
      'PCT': msg.PCT,
      'DRMK': msg.DRMK,
      'OR':(Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'OSC': msg.SC,
      'BID':msg.BID,
      'VD':msg.VD,
      'CTID': msg.CTID,
      'cmdtyId': msg.IID,
      'DT':msg.DT,
    };

    tempMap.set(msg.NOD, obj1);
    for (let i = 0; i < tempFixArray.length; i++) {
      if (tempFixArray[i].orderNo === msg.NOD) {
        tempFixArray[i] = obj;
        break;
      }
    }
    for (let i = 0; i < fixOrdArr.length; i++) {
      if(fixOrdArr[i].orderNo === msg.NOD){
        fixOrdArr[i] = obj2;
        break;
      }
    }

    fixObj.outstandingFix.outstandingFixArr = tempFixArray;
    fixObj.fixOrdersRows = fixOrdArr;
    fixObj.outstandingFix.randomNo = Math.floor((Math.random() * 1000000) + 1);
    fixObj.fixingOrdMap = tempMap;
    fixObj.randomNo = Math.floor((Math.random() * 1000000) + 1);

  }else if (appConstants.FIXING_ORDER_CANCELLED === msg.BCM) {
    var tempFixArrayCancel = [];
    if (fixObj.fixCancellOrd.fixCancellOrdArr !== undefined) {
      if (fixObj.fixCancellOrd.fixCancellOrdArr !== 0) {
        tempFixArrayCancel = fixObj.fixCancellOrd.fixCancellOrdArr;
      }
    }
    for (let i = 0; i < tempFixArray.length; i++) {
      if (tempFixArray[i].orderNo === msg.NOD) {
        tempFixArray.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i < fixOrdArr.length; i++) {
      if (fixOrdArr[i].orderNo === msg.NOD && fixOrdArr[i].status!=='Filled') {
        fixOrdArr.splice(i, 1);
        break;
      }
    }
    tempMap.delete(msg.NOD);
    var obj = {
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL"),
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'cmdtyPair': cmdtypair,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec })),
      'cancelledBy': msg.UCD,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'orderNo': msg.NOD,
      'cmdtyId': msg.IID
    }

    var obj2 = {
      id: msg.ID,
      'placedBy': msg.P_UCD,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Cancelled',
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY": "SELL"),
      'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
      'fixingEvent':msg.FN,
      'fixingEventCode':msg.FC,
      'fixingTime':msg.FT,
      'cmdtyPair': cmdtypair,
      'quantity':(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': msg.SC,
      'rate': "",
      'orderNo': (msg.NOD ? msg.NOD : ""),
      'docNo':'',
      'cancelledBy': msg.UCD,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selectable': false
    };
    tempFixArrayCancel.unshift(obj);
    fixOrdArr.unshift(obj2);
    fixObj.fixCancellOrd.fixCancellOrdArr = tempFixArrayCancel;
    fixObj.fixCancellOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    fixObj.outstandingFix.outstandingFixArr = tempFixArray;
    fixObj.fixOrdersRows = fixOrdArr;
    fixObj.outstandingFix.randomNo = Math.floor((Math.random() * 1000000) + 1);
    fixObj.fixingOrdMap = tempMap;
    fixObj.randomNo = Math.floor((Math.random() * 1000000) + 1);

  }else if(appConstants.FIXING_ORDER_MANUAL_FILL === msg.BCM || appConstants.FIXING_ORDER_FILLED === msg.BCM){
    try{
      for (let i = 0; i < tempFixArray.length; i++) {
        if (tempFixArray[i].orderNo === msg.NOD) {
          tempFixArray.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < fixOrdArr.length; i++) {
        if (fixOrdArr[i].orderNo === msg.NOD) {
          fixOrdArr.splice(i, 1);
          break;
        }
      }
      var tempFixArrayFill = []
      if (fixObj.fixFillOrd.fixFillOrdArr !== undefined) {
        if (fixObj.fixFillOrd.fixFillOrdArr.length !== 0) {
          var tempFixArrayFill = fixObj.fixFillOrd.fixFillOrdArr;
        }
      }
      var obj = {
        'placedBy': msg.P_UCD,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY": "SELL"),
        'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
        'fixingEvent':msg.FN,
        'fixingEventCode':msg.FC,
        'fixingTime':msg.FT,
        'cmdtyPair': cmdtypair,
        'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'qtyType': msg.SC,
        'rate': Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
        'docNo': msg.DN,
        'orderNo': msg.NOD,
        'valDate': moment(msg.VD).format(appConstants.rptDateFormat),
        'comments': msg.RMK,
        'filledBy': msg.UCD,
        'accDescription': msg.AD,
        'cmdtyId': msg.IID
      };
      var obj2 = {
        id: msg.ID,
        'placedBy': msg.P_UCD,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status':'Filled',
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY": "SELL"),
        'fixingDate':moment(msg.FD).format(appConstants.rptDateFormat),
        'fixingEvent':msg.FN,
        'fixingEventCode':msg.FC,
        'fixingTime':msg.FT,
        'cmdtyPair': cmdtypair,
        'quantity': (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'qtyType': msg.SC,
        'rate':Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
        'orderNo': (msg.NOD
          ? msg.NOD
          : ""),
        'docNo':msg.DN,
        'filledBy': msg.UCD,
        'accDescription':msg.AD,
        'comments': msg.RMK,
        'cmdtyId': msg.IID,
        'selectable': false
      };
      tempFixArrayFill.unshift(obj);
      fixOrdArr.unshift(obj2);
      fixObj.fixingOrdMap = tempMap;
      fixObj.outstandingFix.outstandingFixArr = tempFixArray;
      fixObj.outstandingFix.randomNo = Math.floor((Math.random() * 1000000) + 1);
      fixObj.fixFillOrd.fixFillOrdArr = tempFixArrayFill;
      fixObj.fixFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
      fixObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
      fixObj.fixOrdersRows = fixOrdArr;

    }catch(e){console.log(e);}
  }
  let openedWidgets = localStorage.getItem('openedWidgets');
  let flag= 0;
  if (openedWidgets )
  {
    JSON.parse(openedWidgets).map((widget) => {
      if (widget.substring(0, 16) === "OutstandingOrder") {
        flag=1;
      }
    })
  }
  if(flag === 1){
    localStorage.setItem('fixingOrdBook', JSON.stringify(fixObj));
  }
  //localStorage.setItem('outstandingLm', JSON.stringify(fixObj.outstandingLm));
  return fixObj;
}

export function fixingNotifyObj(msg, fixObj) {
  let metal;
  let curr;
  var dec = getDecimal(msg.IID);
  const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  metal = item.D1;
  curr = item.D2;
  let cmdtyDesc=item.ID;
  if(msg.RMK===undefined){
    msg.RMK="";
  }
  if (msg.BCM === appConstants.FIXING_ORDER_MANUAL_FILL || msg.BCM === appConstants.FIXING_ORDER_FILLED) {
    let remark = "";
    let remark2 ="";
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
        remark = "BOUGHT" +
          " " +(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + cmdtyDesc +  " @" + " " + (msg.R
          ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
          : "0") + " ";
      } else {
        remark = "SOLD" +
          " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + cmdtyDesc +  " @" + " " + (msg.R
          ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
          : "0") + " ";
      }
    var obj = {
      flag: true,
      title: "Fixing",
      eventType: "FILLED",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      fixingEvent: msg.FN,
      docNo: msg.NOD,
      fncNo: msg.DN,
      fixingDate:moment(msg.FD).format(appConstants.rptDateFormat),
      trader: msg.UCD,
      remark: remark,
      comments:msg.RMK,
      remark2: ""
    };
    return obj;
  }else if (msg.BCM === appConstants.FIXING_ORDER_MODIFIED) {
    let remark = "";
    let remark2 = "";
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + cmdtyDesc + " ";
      // remark2 = "Old: "+"BUY" +
        remark2 = "BUY" +
        " " + (Number(parseFloat(msg.OPQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.OSC
        ? msg.OSC
        : "") + " " + cmdtyDesc + " ";
    } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + cmdtyDesc + " ";
      // remark2 = "Old: "+"SELL" +
      remark2 = "SELL" +
        " " + (Number(parseFloat(msg.OPQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.OSC
        ? msg.OSC
        : "") + " " + cmdtyDesc+ " ";
    }
    var obj = {
      flag: true,
      title: "Fixing",
      eventType: "MODIFIED",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      fixingEvent: msg.FN,
      docNo: msg.DN,
      fixingDate:moment(msg.FD).format(appConstants.rptDateFormat),
      trader: msg.UCD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2
    };
    return obj;
  } else if (msg.BCM === appConstants.FIXING_ORDER_CANCELLED) {
    let remark = "";
    let remark2 = "";
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + cmdtyDesc + " ";
      } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + cmdtyDesc  + " ";
      }
    var obj = {
      flag: true,
      title: "Fixing",
      eventType: "CANCELLED",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      fixingEvent: msg.FN,
      docNo: msg.DN,
      fixingDate:moment(msg.FD).format(appConstants.rptDateFormat),
      trader: msg.UCD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2
    };
    return obj;
  }
  else {
    return fixObj;
  }
}

function executeModifyRemark(remark, rmkOneParams, remark2, rmkTwoParams){
   remark = rmkOneParams.type + " " +
          (Number(parseFloat(rmkOneParams.pq)).toLocaleString(navigator.language,
            { minimumFractionDigits: rmkOneParams.minFracDigit })) + " " + (rmkOneParams.sc
              ? rmkOneParams.sc
              : "")
          + " " + rmkOneParams.cmdtyDesc + " @ " +
          (Number(parseFloat(rmkOneParams.r)).toLocaleString(navigator.language,{ minimumFractionDigits: rmkOneParams.minFracDigit2 }))
          + ", " + (parseInt(rmkOneParams.vt) === rmkOneParams.gtd ?
                    "GTD "+moment(parseFloat(rmkOneParams.time)).format(rmkOneParams.valDatform) :
                    (parseInt(rmkOneParams.vt) === rmkOneParams.day ? "DAY"
                     : parseInt(rmkOneParams.vt) === 60 ?
                    "GTT "+moment(parseFloat(rmkOneParams.time)).format(rmkOneParams.valGTTformat) :"GTC"));

  // remark2 = "Old: "+ rmkTwoParams.type +
  remark2 =rmkTwoParams.type +
        " " + (Number(parseFloat(rmkTwoParams.opq)).toLocaleString(navigator.language,{ minimumFractionDigits: rmkTwoParams.minFracDigit })) + " " + (rmkTwoParams.sc
        ? rmkTwoParams.sc
        : "") + " " + rmkTwoParams.cmdtyDesc + " @ " + (Number(parseFloat(rmkTwoParams.qr)).toLocaleString(navigator.language,{ minimumFractionDigits: rmkTwoParams.minFracDigit2 }))
         + ", "+(parseInt(rmkTwoParams.vt) === rmkTwoParams.gtd ? "GTD "+moment(parseFloat(rmkTwoParams.otime)).format(rmkTwoParams.valDatform) : (parseInt(rmkTwoParams.vt) === rmkTwoParams.day ? "DAY"
         : parseInt(rmkTwoParams.vt) === 60 ? "GTT "+moment(parseFloat(rmkTwoParams.otime)).format(rmkTwoParams.valGTTformat) :"GTC"));
  var remarkData = "";
  return remarkData = {
    remark1 : remark,
    remark2 : remark2
  }
}
function executeCancelRemark(remark, rmkOneParams){
  remark = rmkOneParams.type +
  " " + (Number(parseFloat(rmkOneParams.gq)-parseFloat((rmkOneParams.tfq !== undefined?parseFloat(rmkOneParams.tfq):0))).toLocaleString(navigator.language,{ minimumFractionDigits: rmkOneParams.minFracDigit })) + " " + (rmkOneParams.sc
  ? rmkOneParams.sc
  : "") + " " + rmkOneParams.cmdtyDesc + " @ " + (Number(parseFloat(rmkOneParams.r)).toLocaleString(navigator.language,{ minimumFractionDigits: rmkOneParams.minFracDigit2 }))
  + ", "+(parseInt(rmkOneParams.vt) === rmkOneParams.gtd ? "GTD "+moment(parseFloat(rmkOneParams.time)).format(rmkOneParams.valDatform) : (parseInt(rmkOneParams.vt) === rmkOneParams.day ? "DAY"
   : parseInt(rmkOneParams.vt) === 60 ? "GTT "+moment(parseFloat(rmkOneParams.time)).format(rmkOneParams.valGTTformat) :"GTC"));
  var rematkData = remark;
  return rematkData;
}
const setOrdCTID = (ctid ,ordersCTID) =>{
  ordersCTID.push(ctid);
  return ordersCTID;
}
const updateCtid =(msg,trdCTID)=>{
  if (msg.BCM === appConstants.TRADE_REQUEST_CONFIRMED || msg.BCM === appConstants.TRADE_REQUEST_REJCTED ||
    msg.BCM === appConstants.MARGIN_CHECKS_FAILED || msg.BCM === appConstants.INITIAL_CHECKS_FAILED || msg.BCM === appConstants.OPEN_POSITION_CHECKS_FAILED){
    trdCTID= null;
  }
  return trdCTID;
}

const setRefreshFlag = () => {
  localStorage.setItem('LoadFlag',false);
  return false;
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SUCCESS_DEFAULT:
      return {
        ...state
      };
    case types.FAILURE_DEFAULT:
      return {
        ...state
      };
    case types.LOAD_ACTIVITYCOMPONENT:
      return {
        ...state
      };
    case types.UPDATE_ACTIVITYCOMPONENT:
      var actLogRandomNo=Math.floor((Math.random() * 100) + 1);
      return {
        ...state,
        activityLog: actLogGenerator(action.msg, state.activityLog),
        actLogRandomNo:actLogRandomNo,
        ordcnfrmsg: ordcnfrmsgGenerator(action.msg, state.ordcnfrmsg),
        tradeBook: trdeBookSet(action.msg, state.tradeBook),
        lmtFillModExpObj:limitFileeObj(action.msg,state.lmtFillModExpObj),
        limitOrdBook:setLimitOrdBook(action.msg, state.limitOrdBook),
        requestRejectModal:setRequestRejectModal(action.msg,state.requestRejectModal),
        trdCTID:updateCtid(action.msg,state.trdCTID),
        statusChanged: checkStatusChange(action.msg,state.statusChanged),
        dealerSelectionFlag:isSingleCancel(action.msg),
        fixingNotifyObj:fixingNotifyObj(action.msg,state.fixingNotifyObj),
        fixingOrdBook:setFixingOrdBook(action.msg, state.fixingOrdBook),
        invalidCheck:action.msg.BCM===appConstants.INVALID_CHECK?{flag:true,Msg:"Trade request rejected because of invalid parameters. Please clear browser cache using 'ctrl + shift + r' key combination over the browser, and then relogin."}:state.invalidCheck
      };
    case types.UPDATE_PHYSICAL_DELIVERY_ACTIVITY:
      var actLogRandomNo=Math.floor((Math.random() * 100) + 1);

      const updatedLog = updatePhysicalDeliveryActivity(action.msg, state.activityLog);
      localStorage.setItem("activityLog", JSON.stringify(updatedLog));


      const physicalDeliveryOrdCnfrmMsg = physicalOrderCnfrmMsgGenerator(action.msg, state.physicalDeliveryOrdCnfrmMsg);

      return {
        ...state,
        activityLog: updatedLog,
        physicalDeliveryOrdCnfrmMsg: physicalDeliveryOrdCnfrmMsg,
        actLogRandomNo: actLogRandomNo

      };
    case types.ADD_ACTIVITYCOMPONENT:
      return {
        ...state,
        activityLog: activityuserLoggedIn(action.msg, state.activityLog)
      }
    case types.UPDATE_ORDCNFMSG:
      //localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
      return {
        ...state,
        ordcnfrmsg: {}
      }
    case types.UPDATE_PHYSICAL_DELIVERY_ORD_CNFRM_MSG:
      return {
        ...state,
        physicalDeliveryOrdCnfrmMsg: {}
      };
    case types.CLOSE_INVALIDCHECKMODAL:
    return {
      ...state,
      invalidCheck: {flag:false, Msg:""}
    }
    case types.RESET_STATE:
      localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
      localStorage.setItem('activityLog', []);
      localStorage.setItem('tradeBook',  JSON.stringify({}));
      localStorage.setItem('fixingOrdBook', JSON.stringify({}));
      localStorage.setItem('limitOrdBook', JSON.stringify({}));
      localStorage.setItem('opentradeBook',  JSON.stringify({}));
      return {
        ...state,
        activityLog: [],
        ordcnfrmsg: {},
        tradeBook: { tradeBookArray:[],randomNo:0},
        limitOrdBook:{
          outstandingLm:{outstandingLmArr:[],randomNo:0},
          limitOrdMap:null,
          lmCancellOrd:{lmCancellOrdArr:[],randomNo:0},
          lmFillOrd:{lmFillOrdArr:[],randomNo:0},
          lmExpOrd:{lmExpOrdArr:[],randomNo:0},
          lmtOrdersRows:[],
          randomNo:0,
          randomNopro:0
        },
        fixingOrdBook:{
          outstandingFix:{outstandingFixArr:[],randomNo:0},
          fixingOrdMap:null,
          fixCancellOrd:{fixCancellOrdArr:[],randomNo:0},
          fixFillOrd:{fixFillOrdArr:[],randomNo:0},
          fixOrdersRows:[],
          randomNo:0,
          randomNopro:0
        },
        lmtFillModExpObj:{
          title: "",
          eventType: "",
          flag: false,
          ts: "",
          fixingEvent: "",
          docNo: "",
          fncNo:"",
          fixingDate:"",
          buyer: "",
          remark: "",
          remark2: ""
        },
        fixingNotifyObj:{
          title: "",
          eventType: "",
          flag: false,
          ts: "",
          fixingEvent: "",
          docNo: "",
          fncNo:"",
          fixingDate:"",
          buyer: "",
          remark: "",
          remark2: ""
        },
        opentradeBook: {
          opentradesData:null,
          randomNo: 0,
        },
        statusChanged:[]
      }
    case types.CLOSE_BM_MODAL:
      return {
        ...state,
        fixingNotifyObj:{
          title: "",
          eventType: "",
          flag: false,
          ts: "",
          fixingEvent: "",
          docNo: "",
          fncNo:"",
          fixingDate:"",
          buyer: "",
          remark: "",
          remark2: ""
        },
        lmtFillModExpObj:{
          title: "",
          eventType: "",
          flag: false,
          ts: "",
          fixingEvent: "",
          docNo: "",
          fncNo:"",
          fixingDate:"",
          buyer: "",
          remark: "",
          remark2: ""
        }
      }
    case types.CLOSE_REQ_REJECTED_MODAL:
      return {
        ...state,
        requestRejectModal: closeReqRejectModal(action.requestRejectModal),
      }
    case types.GET_ALL_ORDER_DATA:
        return {
          ...state,
        };
    case types.GET_ALL_ORDER_DATA_SUCCESS:
      var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
      localStorage.setItem('randomNoDB', refreshRandomNo);
      var requestRejectModal=[{mdflag:false,title:"",msg:"",CTID:"",bcm:""}];
      localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
      return {
        ...state,
        randomNoDB:refreshRandomNo,
        ordersRandomNoDB:refreshRandomNo,
        openTrdRandomNoDB:refreshRandomNo,
        fixOrdRandomNoDB:refreshRandomNo,
        tradeBook: getallspot(action.result.dataObject[1].spotTrades, state.tradeBook),
        outstandingLm: getOutstandingorderLMT(action.result.dataObject[0].outstandingLimitOrd, state.limitOrdBook),
        filledLm: getFilledLMT(action.result.dataObject[0].filledLimitOrd, state.limitOrdBook),
        cancelledLm: getCancelledLMT(action.result.dataObject[0].cancelledLimitOrd, state.limitOrdBook),
        expiredLm:  getExpiredLMT(action.result.dataObject[0].expiredLimitOrd, state.limitOrdBook),
        outstandingFix:getOutstandingFixOrd(action.result.dataObject[2].fixingOutstandingOrd, state.fixingOrdBook),
        filledFix: getFilledFixOrd(action.result.dataObject[2].fixingFillOrd, state.fixingOrdBook),
        cancelledFix: getCancelledFixOrd(action.result.dataObject[2].fixingCancelOrd, state.fixingOrdBook),
        LoadFlag:true,
        orderBookLoaderFlag:true,
        fixOrdLoaderFlag:true
      };
    case types.GET_ALL_ORDER_DATA_FAILURE:
      return {
         ...state,
      };
    case types.GET_TRADEBOOK_DATA:
      return {
        ...state
      };
    case types.GET_TRADEBOOK_DATA_SUCCESS:
      var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
      localStorage.setItem('randomNoDB', refreshRandomNo);
      var requestRejectModal=[{mdflag:false,title:"",msg:"",CTID:"",bcm:""}];
      localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
      return {
        ...state,
        randomNoDB:refreshRandomNo,
        tradeBook: getallspot(action.result.dataObject.spotTrades, state.tradeBook),
        LoadFlag:true
      };
    case types.GET_TRADEBOOK_FAILURE:
      return {
         ...state
      };
    case types.GET_ORDERBOOK_DATA:
      return {
        ...state
      };
    case types.GET_ORDERBOOK_DATA_SUCCESS:
      var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
      localStorage.setItem('randomNoDB', refreshRandomNo);
      var requestRejectModal=[{mdflag:false,title:"",msg:"",CTID:"",bcm:""}];
      localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
      return {
        ...state,
        //randomNoDB:refreshRandomNo,
        ordersRandomNoDB:refreshRandomNo,
        outstandingLm: getOutstandingorderLMT(action.result.dataObject.outstandingLimitOrd, state.limitOrdBook),
        filledLm: getFilledLMT(action.result.dataObject.filledLimitOrd, state.limitOrdBook),
        cancelledLm: getCancelledLMT(action.result.dataObject.cancelledLimitOrd, state.limitOrdBook),
        expiredLm: getExpiredLMT(action.result.dataObject.expiredLimitOrd, state.limitOrdBook),
        //LoadFlag:true,
        orderBookLoaderFlag:true
      };
    case types.GET_ORDERBOOK_FAILURE:
      return {
         ...state
      };
    case types.GET_FIXINGORDER_DATA:
      return {
        ...state,
      };
    case types.GET_FIXINGORDER_DATA_SUCCESS:
      var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
      localStorage.setItem('randomNoDB', refreshRandomNo);
      var requestRejectModal=[{mdflag:false,title:"",msg:"",CTID:"",bcm:""}];
      localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
      return {
        ...state,
        fixOrdRandomNoDB:refreshRandomNo,
        outstandingFix:getOutstandingFixOrd(action.result.dataObject.fixingOutstandingOrd, state.fixingOrdBook),
        filledFix: getFilledFixOrd(action.result.dataObject.fixingFillOrd, state.fixingOrdBook),
        cancelledFix: getCancelledFixOrd(action.result.dataObject.fixingCancelOrd, state.fixingOrdBook),
        fixOrdLoaderFlag:true
      };
    case types.GET_FIXINGORDER_FAILURE:
      return {
        ...state,
      };
    case types.GET_ORDERS_CTID:
      return {
        ...state,
        ordersCTID:setOrdCTID(action.ctid,state.ordersCTID)
      };
    case types.ENABLE_LOADER_FLAG:
      return {
        ...state,
        LoadFlag:action.flag,
        tradebookKey:action.key
      };
    case types.ORDER_REFRESH_FLAG:
      return{
        ...state,
        orderBookLoaderFlag:action.flag
      };
    case types.FIX_ORD_REFRESH_FLAG:
      return{
        ...state,
        fixOrdLoaderFlag:action.flag
      };
    case types.GET_TRADE_CTID:
      if(action.order === 'undefined' || action.order=== undefined){
        action.order=false;
      }else{
        if(!action.order){
          action.ctid=null;
          action.order=true;
          localStorage.setItem('trdCTID',null);
        }else {
          localStorage.setItem('trdCTID',action.ctid);
          action.order=false;
        }
      }
      return {
        ...state,
        trdCTID:action.ctid,
        dealFlag:action.order
      };
    case types.DEAL_FAILED_FLAG:
      if(action.order === 'undefined' || action.order=== undefined){
        action.order=action.flag;
      }else{
        if(!action.order){
          action.order=true;
        }else {
          action.order=false;
        }
      }
      return {
        ...state,
        dealFlag:action.order
      };
    case types.ORDER_SELECTION_SUCCESS_TYPE:
      return{
        ...state,
        orderSelectionFlag:action.flag,
      };
    default:
    return state;
  }
}
